var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyContactIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.107 260.694C174.444 259.822 144.742 260.135 140.158 261.152V270.441C150.559 271.902 168.867 268.274 189.107 260.694ZM140.158 256.289C141.191 256.452 141.766 256.62 142.34 256.62C159.875 256.636 177.41 256.682 194.935 256.575C196.825 256.563 198.935 256.037 200.543 255.071C206.454 251.505 212.272 247.762 217.974 243.868C220.836 241.917 223.373 239.494 226.778 236.687H140.158V256.289ZM247.645 212.753H139.813C140.241 219.53 139.332 225.989 140.335 232.45H231.039C237.305 226.399 242.893 220.35 247.645 212.753ZM140.189 208.421C141.379 208.522 142.152 208.645 142.925 208.646C177.264 208.657 211.593 208.594 245.932 208.737C250.036 208.755 252.135 206.778 253.775 203.595C255.216 200.798 256.731 198.03 258.057 195.177C259.008 193.134 259.697 190.97 260.563 188.686H140.189V208.421ZM139.844 163.591C140.136 170.469 139.51 176.932 140.21 183.461H262.423C265.483 178.719 267.509 168.611 267.404 163.591H139.844ZM271.529 139.423C229.191 139.423 187.499 139.421 145.797 139.428C144.199 139.429 142.612 139.51 141.014 139.578C140.847 139.585 140.68 139.753 140.523 139.87C140.366 139.989 140.231 140.137 140.231 140.145V159.433H268.469C271.759 153.261 269.43 146.402 271.529 139.423ZM140.21 3.87255C140.064 5.40884 139.917 6.17434 139.917 6.9399C139.949 49.4533 140.001 91.9666 140.053 134.481C140.053 134.651 140.178 134.838 140.293 134.987C140.418 135.142 140.586 135.261 140.742 135.41H271.122C269.472 99.8402 257.201 69.2128 232.042 43.798C206.81 18.3005 176.157 5.99783 140.21 3.87255ZM60.8582 245.953L60.8373 245.935C62.9886 249.789 67.2497 250.809 70.5812 253.049C73.3489 254.913 76.4194 256.368 79.4271 257.836C82.2782 259.223 85.3278 260.159 88.2207 261.473C91.0823 262.768 94.0901 264.286 97.1189 264.502C100.482 264.741 102.8 267.267 106.027 267.424C112.022 267.717 117.703 271.552 123.959 268.962C124.241 268.845 124.816 268.985 125.025 269.214C128.377 272.791 132.252 270.467 135.928 270.696V4.33202C134.956 4.22129 134.205 4.0678 133.442 4.06047C125.891 3.98111 118.455 5.23226 111.197 7.04737C105.881 8.37687 100.189 8.29636 95.2598 11.1245C93.902 11.9005 92.5236 13.204 91.1346 13.2416C85.6413 13.3877 81.5263 16.783 76.8161 18.7495C75.5316 19.2832 74.2261 19.8795 73.1504 20.7297C72.1896 21.4878 71.5526 22.6357 70.7379 23.6435C70.3201 23.0535 70.0904 22.7381 69.8711 22.431C57.913 29.844 46.7382 38.2189 37.7983 49.2068C33.0464 55.0344 28.5451 61.0603 23.9708 67.0258C23.5008 67.643 22.7802 68.7971 23.0099 69.1125C24.7122 71.5041 21.9552 71.3277 21.3389 72.3773C19.2502 75.9605 17.1929 79.5918 15.4904 83.3693C14.3521 85.8946 14.3207 89.0132 12.8795 91.2795C11.668 93.1708 10.9579 94.966 10.3938 97.0777C9.61047 100.026 9.2451 103.168 8.28422 105.916C6.11196 112.127 4.71254 118.355 4.60787 124.889C4.50359 130.875 4.79604 136.877 4.47222 142.85C3.74121 156.583 7.7099 169.415 11.6993 182.237C13.0362 186.531 14.9473 190.653 16.7332 194.795C17.5896 196.795 18.6758 198.71 19.8142 200.576C20.8376 202.264 22.2893 203.721 23.1249 205.481C24.0647 207.432 24.4199 209.866 26.5712 210.799C28.9002 211.807 27.6679 214.095 28.848 215.578C36.639 225.377 44.4823 235.13 54.9574 242.264C56.8477 243.557 58.0069 246.165 60.8582 245.953ZM137.536 0C175.813 1.24172 208.909 14.2932 235.676 41.6966C261.911 68.5496 275.237 101.359 274.997 138.608C274.757 176.331 260.595 209.147 233.389 235.689C206.674 261.765 174.434 274.896 137.045 274.752C99.1971 274.607 66.7797 260.995 40.1168 234.19C13.2659 207.197 -0.206565 174.174 0.00239373 136.373C0.190308 99.8819 13.715 68.0181 39.2395 41.8105C66.1217 14.2139 99.4166 1.10283 137.536 0Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.591 76.3481C134.351 76.5162 134.111 76.7929 133.86 76.8097C133.682 76.8222 133.484 76.4817 133.296 76.299C133.421 76.1914 133.578 75.9751 133.682 75.9971C133.996 76.0639 134.288 76.2227 134.591 76.3481Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.08 105.262C114.299 105.08 114.529 104.765 114.717 104.78C114.967 104.797 115.197 105.085 115.427 105.255C115.302 105.377 115.145 105.619 115.04 105.601C114.727 105.548 114.424 105.393 114.08 105.262Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.667 105.26C123.897 105.079 124.116 104.765 124.325 104.779C124.565 104.795 124.795 105.086 125.025 105.257C124.899 105.38 124.743 105.623 124.638 105.604C124.314 105.549 124.012 105.392 123.667 105.26Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.745 105.617C133.62 105.398 133.484 105.18 133.359 104.963C133.672 104.913 133.996 104.821 134.309 104.835C134.435 104.842 134.549 105.083 134.675 105.218C134.361 105.35 134.058 105.484 133.745 105.617Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2624 57.1647C96.0327 57.3475 95.8134 57.6608 95.6149 57.6482C95.3643 57.6315 95.145 57.3412 94.9048 57.1699C95.0407 57.0456 95.1868 56.8034 95.2911 56.8222C95.6149 56.8765 95.9074 57.0331 96.2624 57.1647Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.046 138.648C100.795 138.821 100.544 139.103 100.283 139.127C100.106 139.141 99.8969 138.783 99.7087 138.591C99.8446 138.48 100.001 138.254 100.106 138.277C100.429 138.35 100.732 138.516 101.046 138.648Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.437 8.04893C115.197 8.23379 114.978 8.54823 114.779 8.53466C114.539 8.51898 114.309 8.2276 114.069 8.05531C114.205 7.93203 114.351 7.68866 114.455 7.70637C114.779 7.76177 115.082 7.91737 115.437 8.04893Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.45 7.6739C124.628 7.865 124.805 8.06243 124.983 8.25983C124.68 8.37056 124.367 8.51877 124.053 8.56784C123.949 8.58352 123.803 8.33601 123.677 8.20858C123.928 8.04043 124.168 7.87125 124.45 7.6739Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.745 8.57934C133.609 8.36007 133.484 8.14066 133.348 7.92138C133.672 7.8723 133.996 7.78038 134.309 7.79402C134.435 7.80027 134.56 8.0425 134.675 8.17725C134.361 8.31194 134.058 8.44567 133.745 8.57934Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.811 56.8233C114.999 57.0071 115.197 57.1899 115.385 57.3726C115.082 57.4834 114.779 57.6327 114.455 57.6828C114.362 57.6985 114.215 57.4521 114.09 57.3267C114.33 57.1586 114.57 56.9904 114.811 56.8233Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.427 133.845C115.197 134.029 114.978 134.343 114.779 134.33C114.539 134.313 114.309 134.023 114.08 133.85C114.205 133.728 114.362 133.485 114.466 133.504C114.779 133.558 115.082 133.713 115.427 133.845Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.975 56.8202C134.163 57.003 134.361 57.1868 134.56 57.3706C134.246 57.4823 133.944 57.6327 133.62 57.6838C133.526 57.7006 133.38 57.4531 133.254 57.3257C133.494 57.1565 133.735 56.9884 133.975 56.8202Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.962 13.371C128.826 13.1527 128.701 12.9355 128.575 12.7172C128.889 12.6682 129.212 12.5753 129.526 12.5899C129.651 12.5951 129.766 12.8364 129.881 12.9711C129.578 13.1047 129.265 13.2383 128.962 13.371Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7175 61.6357C42.4981 61.7662 42.2788 61.8968 42.0595 62.0263C42.0072 61.7057 41.9133 61.3831 41.9342 61.0656C41.9342 60.9392 42.1848 60.8254 42.3206 60.7053C42.4564 61.0155 42.592 61.3255 42.7175 61.6357Z",
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.492 17.6384C104.67 17.865 104.983 18.0843 104.973 18.2807C104.952 18.5271 104.67 18.7527 104.492 18.9877C104.377 18.8582 104.137 18.7078 104.147 18.6023C104.2 18.2848 104.356 17.984 104.492 17.6384Z",
    fill: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3255 61.5607C52.1376 61.7372 51.9286 61.9178 51.7301 62.1006C51.6257 61.7873 51.469 61.4803 51.4272 61.1565C51.4064 61.0521 51.6572 60.908 51.7824 60.7816C51.9601 61.027 52.127 61.2734 52.3255 61.5607Z",
    fill: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5236 22.4329C80.7115 22.6647 81.0249 22.8862 81.0145 23.0868C80.9936 23.3321 80.7012 23.56 80.5341 23.7949C80.4086 23.6644 80.1686 23.5129 80.179 23.4064C80.2416 23.0858 80.3983 22.7827 80.5236 22.4329Z",
    fill: "#CCCCCC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.252 23.2205C100.053 23.3917 99.8655 23.5683 99.6672 23.7458C99.5522 23.4378 99.4058 23.136 99.3538 22.8195C99.3329 22.7182 99.5835 22.5751 99.7087 22.4518C99.876 22.692 100.043 22.9322 100.252 23.2205Z",
    fill: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.808 23.2853C109.589 23.4137 109.37 23.5412 109.16 23.6686C109.108 23.3543 109.014 23.0367 109.025 22.7255C109.035 22.6022 109.275 22.4895 109.411 22.3725C109.537 22.6764 109.672 22.9803 109.808 23.2853Z",
    fill: "#CCCCCC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4689 61.7141C71.2287 61.8008 70.9885 61.8864 70.7483 61.972C70.7379 61.6482 70.6961 61.3214 70.7379 61.004C70.7483 60.9152 70.9781 60.8515 71.1138 60.7753C71.2287 61.0886 71.354 61.4008 71.4689 61.7141Z",
    fill: "#CCCCCC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1531 27.2309C66.3307 27.4576 66.6439 27.6768 66.6334 27.8732C66.6125 28.1165 66.3307 28.341 66.1531 28.5728C66.0382 28.4433 65.798 28.2951 65.8189 28.1896C65.8711 27.8731 66.0277 27.5756 66.1531 27.2309Z",
    fill: "#CCCCCC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2731 28.0769C76.0433 28.2106 75.8241 28.3431 75.6048 28.4758C75.5525 28.151 75.4587 27.8252 75.469 27.5036C75.4795 27.3772 75.7196 27.2602 75.8554 27.1391C76.0016 27.4524 76.1374 27.7636 76.2731 28.0769Z",
    fill: "#CCCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8501 28.0736C85.6308 28.2031 85.4114 28.3305 85.1921 28.459C85.1503 28.1446 85.0564 27.8272 85.0668 27.5149C85.0773 27.3906 85.3174 27.2789 85.4532 27.1609C85.5785 27.4658 85.7143 27.7697 85.8501 28.0736Z",
    fill: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.492 27.2248C104.67 27.4556 104.983 27.6781 104.973 27.8785C104.962 28.124 104.67 28.3506 104.492 28.5856C104.367 28.455 104.127 28.3036 104.148 28.1981C104.2 27.8775 104.356 27.5746 104.492 27.2248Z",
    fill: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0564 61.6378C80.8372 61.7683 80.6177 61.8979 80.3985 62.0284C80.3462 61.7068 80.2522 61.384 80.2627 61.0665C80.2731 60.9402 80.5133 60.8263 80.6491 60.7062C80.7849 61.0164 80.9207 61.3266 81.0564 61.6378Z",
    fill: "#CCCCCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4171 110.053C31.6573 109.869 31.8767 109.554 32.0855 109.566C32.3256 109.581 32.5556 109.876 32.7853 110.051C32.66 110.176 32.5033 110.422 32.3989 110.403C32.0752 110.346 31.7723 110.188 31.4171 110.053Z",
    fill: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1034 33.3613C70.9364 33.1169 70.6544 32.8799 70.6335 32.6251C70.623 32.4454 70.9676 32.2418 71.1556 32.0486C71.2601 32.1812 71.4793 32.3378 71.4584 32.4412C71.3958 32.7587 71.2287 33.0564 71.1034 33.3613Z",
    fill: "#CCCCCC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4505 32.0371C80.6699 32.2251 81.0354 32.4225 81.025 32.5635C80.9727 32.8706 80.7325 33.1494 80.5655 33.4397C80.4505 33.3029 80.2312 33.162 80.2417 33.0293C80.2521 32.7129 80.367 32.4006 80.4505 32.0371Z",
    fill: "#CCCCCC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.993 133.77C124.805 133.983 124.607 134.357 124.471 134.337C124.168 134.293 123.886 134.049 123.604 133.888C123.74 133.771 123.876 133.551 124.011 133.557C124.325 133.567 124.638 133.684 124.993 133.77Z",
    fill: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4688 81.1301C91.2391 81.3129 91.0093 81.6272 90.8108 81.6147C90.5706 81.5991 90.341 81.3055 90.111 81.1332C90.2365 81.0089 90.393 80.7656 90.4976 80.7833C90.8214 80.8398 91.1243 80.9975 91.4688 81.1301Z",
    fill: "#CCCCCC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M129.818 90.7091C129.588 90.8939 129.359 91.2104 129.16 91.1968C128.92 91.1801 128.69 90.8887 128.45 90.7165C128.586 90.5932 128.732 90.3499 128.837 90.3676C129.16 90.422 129.463 90.5774 129.818 90.7091Z",
    fill: "#CCCCCC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M134.612 133.843C134.372 134.027 134.152 134.342 133.954 134.33C133.703 134.313 133.473 134.021 133.244 133.848C133.369 133.725 133.526 133.481 133.63 133.499C133.954 133.555 134.257 133.71 134.612 133.843Z",
    fill: "#CCCCCC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M128.461 32.1917C128.69 32.0078 128.899 31.6924 129.098 31.7049C129.348 31.7217 129.568 32.0109 129.808 32.1832C129.672 32.3065 129.526 32.5488 129.421 32.531C129.108 32.4778 128.805 32.3222 128.461 32.1917Z",
    fill: "#CCCCCC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M120.21 81.054C120.022 81.2681 119.823 81.6419 119.677 81.6221C119.374 81.5793 119.092 81.3349 118.81 81.1731C118.946 81.0561 119.082 80.8368 119.218 80.841C119.531 80.8514 119.844 80.9684 120.21 81.054Z",
    fill: "#CCCCCC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M129.818 81.126C129.588 81.3129 129.369 81.6324 129.16 81.6189C128.92 81.6022 128.69 81.3087 128.45 81.1343C128.575 81.009 128.732 80.7635 128.837 80.7823C129.16 80.8366 129.473 80.9934 129.818 81.126Z",
    fill: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.73 36.7827C75.9179 37.0125 76.2418 37.235 76.2208 37.4324C76.2104 37.6851 75.9179 37.919 75.7404 38.1602C75.6151 38.0276 75.3748 37.8763 75.3853 37.7666C75.4375 37.4429 75.5942 37.1367 75.73 36.7827Z",
    fill: "#CCCCCC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7409 65.6075C27.9498 65.7923 28.3153 65.9855 28.2944 66.1255C28.2526 66.4263 28.0124 66.701 27.8559 66.9861C27.7409 66.8514 27.5216 66.7124 27.5321 66.5819C27.5425 66.2707 27.6574 65.9646 27.7409 65.6075Z",
    fill: "#CCCCCC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5527 66.3574C47.3544 66.5297 47.1456 66.7072 46.947 66.8858C46.8322 66.5725 46.6755 66.2644 46.6234 65.9396C46.6129 65.8362 46.8635 65.6899 46.9889 65.5635C47.1663 65.808 47.3335 66.0524 47.5527 66.3574Z",
    fill: "#CCCCCC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8971 66.9234C75.7301 66.6811 75.4376 66.4451 75.4272 66.1924C75.4061 66.0075 75.7508 65.7996 75.939 65.6033C76.0537 65.7359 76.273 65.8925 76.2523 65.998C76.1894 66.3166 76.0224 66.6164 75.8971 66.9234Z",
    fill: "#CCCCCC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M104.419 65.6023C104.628 65.7893 104.993 65.9834 104.973 66.1234C104.931 66.4252 104.69 66.6999 104.534 66.9861C104.419 66.8513 104.2 66.7115 104.2 66.5809C104.21 66.2686 104.325 65.9606 104.419 65.6023Z",
    fill: "#CCCCCC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M128.962 119.991C128.826 119.773 128.701 119.556 128.575 119.339C128.889 119.29 129.212 119.198 129.526 119.211C129.651 119.216 129.766 119.459 129.881 119.593C129.578 119.727 129.265 119.86 128.962 119.991Z",
    fill: "#CCCCCC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M134.602 36.8067C134.372 36.9885 134.152 37.2996 133.954 37.2871C133.714 37.2704 133.484 36.9832 133.254 36.812C133.38 36.6898 133.536 36.4496 133.641 36.4684C133.954 36.5216 134.257 36.6773 134.602 36.8067Z",
    fill: "#CCCCCC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2941 42.3212C52.1062 42.5175 51.9286 42.7128 51.7406 42.9081C51.6257 42.5979 51.4795 42.2929 51.4272 41.9733C51.4064 41.872 51.6572 41.7268 51.7824 41.6015C51.9495 41.8417 52.127 42.0809 52.2941 42.3212Z",
    fill: "#CCCCCC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3956 115.21C95.2703 114.987 95.1346 114.765 95.0092 114.543C95.3329 114.492 95.6567 114.398 95.9701 114.412C96.1059 114.417 96.2207 114.664 96.3356 114.802C96.0222 114.939 95.709 115.074 95.3956 115.21Z",
    fill: "#CCCCCC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9365 41.59C71.1244 41.8177 71.4377 42.0382 71.4273 42.2355C71.4064 42.4841 71.1244 42.7128 70.9468 42.9498C70.8215 42.8182 70.5813 42.669 70.6022 42.5614C70.6545 42.2418 70.811 41.9388 70.9365 41.59Z",
    fill: "#CCCCCC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6804 42.9393C80.5133 42.696 80.2417 42.461 80.2208 42.2062C80.2104 42.0308 80.5551 41.8281 80.7326 41.638C80.8474 41.7696 81.0564 41.9242 81.0355 42.0275C80.9727 42.3419 80.8162 42.6365 80.6804 42.9393Z",
    fill: "#CCCCCC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4688 138.633C91.2391 138.818 91.0093 139.135 90.8108 139.122C90.5706 139.105 90.341 138.812 90.1007 138.638C90.2365 138.513 90.3826 138.268 90.4976 138.287C90.8108 138.343 91.1243 138.501 91.4688 138.633Z",
    fill: "#CCCCCC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7069 71.2921C42.477 71.3767 42.2369 71.4613 41.9967 71.5458C41.9862 71.2263 41.955 70.9025 41.9862 70.5882C41.9967 70.5005 42.2264 70.4368 42.3517 70.3626C42.477 70.6718 42.5919 70.982 42.7069 71.2921Z",
    fill: "#CCCCCC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3047 71.2158C52.0854 71.3453 51.866 71.4748 51.6468 71.6043C51.5946 71.2858 51.5005 70.9641 51.5214 70.6476C51.5214 70.5233 51.7616 70.4095 51.8974 70.2905C52.0332 70.5986 52.1689 70.9067 52.3047 71.2158Z",
    fill: "#CCCCCC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5215 47.2619C47.3021 47.3957 47.0724 47.5272 46.8531 47.6588C46.8009 47.334 46.7069 47.0072 46.7174 46.6854C46.7277 46.5581 46.968 46.4421 47.1038 46.3199C47.25 46.6343 47.3858 46.9486 47.5215 47.2619Z",
    fill: "#CCCCCC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6568 46.4349C75.8762 46.6239 76.2522 46.8203 76.2313 46.9645C76.1893 47.2725 75.939 47.5535 75.7822 47.8449C75.6568 47.708 75.4376 47.5671 75.448 47.4333C75.4586 47.1159 75.5733 46.8004 75.6568 46.4349Z",
    fill: "#CCCCCC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M81.046 71.2943C80.8058 71.3789 80.576 71.4644 80.3359 71.549C80.3253 71.2284 80.2836 70.9047 80.3253 70.5893C80.3359 70.5016 80.5656 70.4389 80.6909 70.3638C80.8058 70.674 80.9311 70.9831 81.046 71.2943Z",
    fill: "#CCCCCC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4792 109.881C91.2391 110.067 91.0093 110.385 90.8108 110.372C90.5602 110.356 90.3305 110.059 90.1007 109.885C90.226 109.758 90.3826 109.512 90.4871 109.531C90.8108 109.587 91.1243 109.746 91.4792 109.881Z",
    fill: "#CCCCCC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4505 205.776C80.6595 205.964 81.0354 206.158 81.0145 206.301C80.9727 206.605 80.7325 206.882 80.576 207.17C80.4505 207.034 80.2312 206.895 80.2417 206.762C80.2521 206.449 80.367 206.138 80.4505 205.776Z",
    fill: "#CCCCCC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M101.056 109.88C100.816 110.069 100.586 110.393 100.377 110.381C100.127 110.367 99.8969 110.06 99.6566 109.881C99.7924 109.752 99.9491 109.498 100.053 109.517C100.388 109.577 100.701 109.741 101.056 109.88Z",
    fill: "#CCCCCC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M115.427 114.684C115.186 114.856 114.946 115.14 114.696 115.158C114.508 115.17 114.309 114.823 114.111 114.637C114.247 114.526 114.403 114.305 114.508 114.328C114.821 114.396 115.124 114.556 115.427 114.684Z",
    fill: "#CCCCCC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M119.395 110.415C119.26 110.194 119.124 109.973 118.988 109.752C119.312 109.7 119.635 109.605 119.959 109.619C120.085 109.624 120.199 109.87 120.325 110.006C120.011 110.143 119.709 110.28 119.395 110.415Z",
    fill: "#CCCCCC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M129.839 109.874C129.599 110.066 129.38 110.395 129.171 110.38C128.92 110.362 128.68 110.063 128.44 109.886C128.575 109.758 128.732 109.509 128.837 109.527C129.171 109.581 129.473 109.741 129.839 109.874Z",
    fill: "#CCCCCC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8839 86.0993C95.1136 85.9113 95.3433 85.5875 95.5418 85.6011C95.7925 85.6199 96.0222 85.9124 96.2624 86.0868C96.1371 86.2121 95.9805 86.4585 95.876 86.4397C95.5523 86.3875 95.2389 86.2309 94.8839 86.0993Z",
    fill: "#CCCCCC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97095 115.205C7.84562 114.986 7.70985 114.765 7.57408 114.546C7.89777 114.494 8.2216 114.4 8.54528 114.413C8.6706 114.419 8.78546 114.664 8.90033 114.8C8.59742 114.935 8.28418 115.071 7.97095 115.205Z",
    fill: "#CCCCCC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M114.581 86.4544C114.445 86.233 114.32 86.0126 114.184 85.7913C114.508 85.7411 114.831 85.6471 115.145 85.6607C115.281 85.667 115.395 85.9123 115.51 86.048C115.197 86.1838 114.894 86.3197 114.581 86.4544Z",
    fill: "#CCCCCC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9287 159.159C51.7616 158.916 51.4796 158.68 51.4692 158.428C51.4484 158.247 51.793 158.043 51.981 157.849C52.0959 157.98 52.3152 158.137 52.2838 158.24C52.2212 158.557 52.0645 158.854 51.9287 159.159Z",
    fill: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4689 158.659C71.2497 158.79 71.0304 158.92 70.811 159.05C70.7693 158.731 70.6752 158.411 70.6857 158.094C70.6961 157.97 70.9364 157.854 71.0721 157.736C71.2078 158.043 71.3332 158.351 71.4689 158.659Z",
    fill: "#CCCCCC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0564 158.657C80.8371 158.788 80.6177 158.918 80.3984 159.048C80.3461 158.728 80.2522 158.409 80.2731 158.091C80.2731 157.967 80.5133 157.852 80.6491 157.733C80.7848 158.041 80.9206 158.349 81.0564 158.657Z",
    fill: "#CCCCCC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6983 157.81C99.8759 158.039 100.2 158.259 100.179 158.458C100.168 158.702 99.8759 158.928 99.7087 159.161C99.5835 159.031 99.3433 158.882 99.3538 158.776C99.4165 158.458 99.5626 158.157 99.6983 157.81Z",
    fill: "#CCCCCC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M109.798 158.539C109.609 158.73 109.432 158.922 109.244 159.112C109.14 158.806 108.993 158.506 108.941 158.191C108.92 158.09 109.171 157.948 109.296 157.826C109.463 158.064 109.63 158.3 109.798 158.539Z",
    fill: "#CCCCCC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7595 163.435C18.5401 163.568 18.3207 163.699 18.1014 163.832C18.0491 163.509 17.9552 163.188 17.9656 162.868C17.9762 162.743 18.2162 162.627 18.352 162.506C18.4878 162.816 18.6236 163.125 18.7595 163.435Z",
    fill: "#CCCCCC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5216 163.435C47.3022 163.571 47.0724 163.706 46.8531 163.842C46.8009 163.514 46.6965 163.185 46.7174 162.86C46.7174 162.732 46.968 162.614 47.1038 162.492C47.2396 162.807 47.3858 163.12 47.5216 163.435Z",
    fill: "#CCCCCC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6569 162.609C75.8763 162.799 76.2523 162.999 76.2419 163.142C76.1894 163.454 75.9493 163.737 75.7822 164.033C75.6569 163.894 75.4376 163.752 75.4376 163.617C75.4481 163.295 75.5629 162.978 75.6569 162.609Z",
    fill: "#CCCCCC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M105.014 163.44C104.795 163.571 104.576 163.702 104.356 163.832C104.315 163.513 104.221 163.193 104.231 162.877C104.241 162.752 104.482 162.637 104.618 162.518C104.753 162.825 104.879 163.132 105.014 163.44Z",
    fill: "#CCCCCC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M133.244 162.774C133.473 162.59 133.693 162.274 133.891 162.288C134.132 162.304 134.361 162.592 134.601 162.765C134.466 162.888 134.319 163.129 134.215 163.113C133.891 163.059 133.588 162.905 133.244 162.774Z",
    fill: "#CCCCCC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9473 157.842C23.1562 158.028 23.532 158.225 23.5113 158.367C23.4694 158.674 23.2291 158.953 23.0621 159.242C22.9473 159.106 22.728 158.966 22.728 158.834C22.7384 158.517 22.8533 158.204 22.9473 157.842Z",
    fill: "#CCCCCC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2942 168.308C52.054 168.391 51.8138 168.473 51.5736 168.556C51.5632 168.231 51.5318 167.902 51.5736 167.582C51.5841 167.497 51.8138 167.437 51.9496 167.365C52.0645 167.68 52.1793 167.993 52.2942 168.308Z",
    fill: "#CCCCCC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M129.797 167.402C129.557 167.571 129.327 167.853 129.077 167.87C128.899 167.881 128.69 167.54 128.502 167.355C128.628 167.246 128.784 167.028 128.889 167.05C129.202 167.117 129.494 167.276 129.797 167.402Z",
    fill: "#CCCCCC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2627 172.882C76.0747 173.083 75.8865 173.286 75.6987 173.487C75.5839 173.172 75.4272 172.864 75.3749 172.539C75.3541 172.437 75.6152 172.29 75.7405 172.164C75.918 172.402 76.0851 172.642 76.2627 172.882Z",
    fill: "#CCCCCC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M114.863 171.801C115.03 171.991 115.207 172.19 115.385 172.389C115.071 172.499 114.779 172.648 114.455 172.698C114.361 172.714 114.215 172.468 114.1 172.342C114.33 172.174 114.57 172.008 114.863 171.801Z",
    fill: "#CCCCCC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M134.591 172.194C134.351 172.363 134.111 172.641 133.86 172.658C133.682 172.671 133.484 172.329 133.286 172.145C133.422 172.038 133.578 171.82 133.682 171.842C133.996 171.909 134.288 172.069 134.591 172.194Z",
    fill: "#CCCCCC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3599 177.011C13.5794 177.197 13.9448 177.39 13.9239 177.531C13.8821 177.833 13.6419 178.109 13.4852 178.394C13.3599 178.259 13.151 178.12 13.151 177.99C13.1615 177.677 13.2765 177.368 13.3599 177.011Z",
    fill: "#CCCCCC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M23.553 177.82C23.3337 177.952 23.1145 178.082 22.8951 178.214C22.8429 177.893 22.7488 177.57 22.7593 177.253C22.7697 177.127 23.0099 177.012 23.1457 176.892C23.2815 177.201 23.4173 177.51 23.553 177.82Z",
    fill: "#CCCCCC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1847 176.967C42.3726 177.196 42.686 177.417 42.6755 177.615C42.6546 177.863 42.3726 178.092 42.1952 178.329C42.0697 178.199 41.8295 178.047 41.8504 177.941C41.9027 177.62 42.0594 177.317 42.1847 176.967Z",
    fill: "#CCCCCC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M51.772 176.964C51.9602 177.194 52.2733 177.416 52.2628 177.614C52.242 177.864 51.9496 178.093 51.7825 178.332C51.6573 178.201 51.4169 178.049 51.4273 177.942C51.4795 177.62 51.6362 177.315 51.772 176.964Z",
    fill: "#CCCCCC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1034 178.319C70.9364 178.076 70.6544 177.84 70.6335 177.588C70.623 177.41 70.9676 177.207 71.1556 177.015C71.2601 177.147 71.4793 177.301 71.4584 177.406C71.3854 177.72 71.2287 178.016 71.1034 178.319Z",
    fill: "#CCCCCC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5237 176.967C80.7116 177.197 81.025 177.417 81.0145 177.615C80.9936 177.863 80.7013 178.091 80.5342 178.328C80.4087 178.197 80.1687 178.047 80.1894 177.939C80.2417 177.62 80.3879 177.317 80.5237 176.967Z",
    fill: "#CCCCCC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M100.221 177.701C100.033 177.894 99.8446 178.088 99.6672 178.281C99.5522 177.973 99.4058 177.672 99.3538 177.355C99.3329 177.254 99.5835 177.111 99.7087 176.988C99.876 177.225 100.043 177.463 100.221 177.701Z",
    fill: "#CCCCCC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3938 183.131C18.2162 182.893 17.9342 182.659 17.9236 182.411C17.9134 182.226 18.2476 182.02 18.4356 181.823C18.54 181.956 18.7594 182.111 18.7384 182.216C18.6758 182.53 18.5191 182.827 18.3938 183.131Z",
    fill: "#CCCCCC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1455 183.143C46.9679 182.901 46.6859 182.664 46.665 182.413C46.6546 182.223 46.9992 182.015 47.1871 181.815C47.302 181.949 47.5214 182.105 47.5005 182.213C47.4379 182.533 47.2708 182.833 47.1455 183.143Z",
    fill: "#CCCCCC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6568 181.813C75.8762 182.002 76.2522 182.198 76.2313 182.343C76.1893 182.651 75.939 182.931 75.7822 183.221C75.6568 183.085 75.4376 182.944 75.448 182.812C75.4586 182.493 75.5733 182.179 75.6568 181.813Z",
    fill: "#CCCCCC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3047 187.436C52.0854 187.568 51.866 187.697 51.6467 187.828C51.5946 187.505 51.5005 187.181 51.5109 186.862C51.5214 186.736 51.7616 186.62 51.8974 186.501C52.0331 186.813 52.1689 187.124 52.3047 187.436Z",
    fill: "#CCCCCC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 187.672C129.588 187.885 129.401 188.257 129.254 188.237C128.952 188.195 128.68 187.954 128.398 187.793C128.523 187.676 128.669 187.459 128.795 187.463C129.108 187.474 129.421 187.589 129.776 187.672Z",
    fill: "#CCCCCC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.433 157.809C13.6209 158.038 13.9343 158.257 13.9134 158.456C13.903 158.7 13.6105 158.927 13.4435 159.16C13.3182 159.03 13.078 158.881 13.0988 158.775C13.151 158.458 13.3077 158.156 13.433 157.809Z",
    fill: "#CCCCCC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1536 191.395C18.3624 191.584 18.7488 191.782 18.7279 191.925C18.6862 192.233 18.4356 192.515 18.2791 192.807C18.1536 192.669 17.9342 192.53 17.9342 192.396C17.9447 192.077 18.07 191.761 18.1536 191.395Z",
    fill: "#CCCCCC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9784 191.347C47.1663 191.584 47.4901 191.813 47.4796 192.021C47.4587 192.269 47.156 192.5 46.9784 192.739C46.853 192.607 46.6024 192.451 46.6233 192.345C46.6859 192.014 46.8426 191.704 46.9784 191.347Z",
    fill: "#CCCCCC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6569 191.391C75.8763 191.581 76.2523 191.78 76.2313 191.924C76.1894 192.236 75.9493 192.52 75.7822 192.815C75.6569 192.677 75.4376 192.535 75.4376 192.4C75.4481 192.079 75.5629 191.76 75.6569 191.391Z",
    fill: "#CCCCCC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M105.035 192.139C104.837 192.316 104.649 192.497 104.45 192.68C104.335 192.369 104.189 192.065 104.137 191.745C104.127 191.642 104.377 191.498 104.502 191.372C104.67 191.617 104.837 191.862 105.035 192.139Z",
    fill: "#CCCCCC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M114.581 193.062C114.455 192.845 114.33 192.629 114.205 192.413C114.518 192.364 114.831 192.273 115.145 192.287C115.27 192.294 115.374 192.534 115.5 192.667C115.197 192.8 114.884 192.932 114.581 193.062Z",
    fill: "#CCCCCC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5843 196.938C23.3859 197.109 23.1874 197.287 22.9787 197.464C22.8637 197.152 22.7175 196.845 22.6652 196.523C22.6443 196.421 22.895 196.275 23.0307 196.149C23.1979 196.393 23.3755 196.635 23.5843 196.938Z",
    fill: "#CCCCCC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3517 197.495C42.1847 197.254 41.9027 197.018 41.8818 196.766C41.8713 196.585 42.216 196.381 42.3935 196.187C42.5083 196.319 42.7277 196.475 42.7069 196.578C42.6337 196.895 42.477 197.19 42.3517 197.495Z",
    fill: "#CCCCCC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6989 196.174C51.9076 196.363 52.2837 196.561 52.2733 196.704C52.2316 197.012 51.9809 197.292 51.8243 197.583C51.6989 197.446 51.4795 197.305 51.4795 197.172C51.49 196.854 51.6153 196.539 51.6989 196.174Z",
    fill: "#CCCCCC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9364 196.14C71.1243 196.372 71.448 196.595 71.4377 196.797C71.4168 197.045 71.1243 197.274 70.9467 197.511C70.8214 197.379 70.5812 197.228 70.5917 197.121C70.6544 196.797 70.811 196.491 70.9364 196.14Z",
    fill: "#CCCCCC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0458 196.879C80.8578 197.073 80.6803 197.269 80.4923 197.462C80.3774 197.151 80.2312 196.846 80.1791 196.525C80.1583 196.422 80.4087 196.277 80.5341 196.151C80.7116 196.395 80.8787 196.636 81.0458 196.879Z",
    fill: "#CCCCCC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M100.221 196.873C100.033 197.066 99.8446 197.26 99.6672 197.453C99.5522 197.145 99.4058 196.842 99.3538 196.524C99.3329 196.423 99.5835 196.279 99.7087 196.155C99.876 196.395 100.053 196.634 100.221 196.873Z",
    fill: "#CCCCCC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M109.213 196.186C109.422 196.371 109.787 196.566 109.766 196.707C109.724 197.01 109.484 197.283 109.328 197.57C109.213 197.435 108.993 197.295 108.993 197.164C109.004 196.852 109.119 196.543 109.213 196.186Z",
    fill: "#CCCCCC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7409 200.982C27.9498 201.166 28.3153 201.36 28.2944 201.499C28.2526 201.799 28.0124 202.072 27.8559 202.356C27.7409 202.221 27.5216 202.083 27.5321 201.953C27.5425 201.644 27.6574 201.338 27.7409 200.982Z",
    fill: "#CCCCCC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5215 201.79C47.2917 201.924 47.0724 202.056 46.8531 202.189C46.8009 201.864 46.7069 201.538 46.7174 201.217C46.7277 201.09 46.968 200.973 47.1038 200.852C47.2395 201.164 47.3858 201.476 47.5215 201.79Z",
    fill: "#CCCCCC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7223 202.277C56.5553 202.037 56.2838 201.807 56.2628 201.558C56.2524 201.38 56.5865 201.181 56.7746 200.991C56.879 201.12 57.0877 201.274 57.067 201.376C57.0043 201.686 56.8476 201.977 56.7223 202.277Z",
    fill: "#CCCCCC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2731 201.79C76.0433 201.922 75.8241 202.055 75.6048 202.187C75.5525 201.863 75.4587 201.538 75.469 201.218C75.4795 201.091 75.7196 200.975 75.8554 200.854C76.0016 201.166 76.1374 201.478 76.2731 201.79Z",
    fill: "#CCCCCC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M104.408 200.976C104.628 201.163 104.993 201.358 104.973 201.498C104.931 201.8 104.69 202.076 104.534 202.363C104.419 202.228 104.2 202.088 104.2 201.957C104.21 201.644 104.325 201.335 104.408 200.976Z",
    fill: "#CCCCCC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1847 205.736C42.3726 205.967 42.686 206.19 42.6755 206.391C42.6546 206.635 42.3622 206.861 42.1952 207.095C42.0697 206.965 41.8295 206.813 41.8504 206.708C41.9027 206.387 42.0594 206.084 42.1847 205.736Z",
    fill: "#CCCCCC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9391 207.091C51.7615 206.851 51.4795 206.618 51.4691 206.369C51.4587 206.184 51.7929 205.977 51.9809 205.781C52.0853 205.913 52.3046 206.068 52.2837 206.173C52.2211 206.49 52.0644 206.786 51.9391 207.091Z",
    fill: "#CCCCCC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4689 206.594C71.2497 206.724 71.0304 206.853 70.811 206.982C70.7693 206.664 70.6752 206.342 70.6857 206.026C70.6961 205.902 70.9364 205.788 71.0721 205.67C71.2078 205.977 71.3332 206.285 71.4689 206.594Z",
    fill: "#CCCCCC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2627 153.859C76.0433 153.992 75.8241 154.124 75.6048 154.255C75.5525 153.934 75.4587 153.611 75.469 153.291C75.4795 153.166 75.7301 153.051 75.8554 152.931C75.9912 153.239 76.127 153.549 76.2627 153.859Z",
    fill: "#CCCCCC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M128.461 207.088C128.69 206.905 128.91 206.592 129.098 206.607C129.348 206.623 129.568 206.91 129.797 207.082C129.672 207.204 129.526 207.444 129.421 207.425C129.098 207.371 128.805 207.218 128.461 207.088Z",
    fill: "#CCCCCC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M115.416 211.726C115.176 211.894 114.946 212.171 114.696 212.188C114.518 212.199 114.32 211.86 114.121 211.677C114.257 211.571 114.414 211.354 114.508 211.376C114.821 211.443 115.113 211.601 115.416 211.726Z",
    fill: "#CCCCCC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M134.591 211.725C134.351 211.894 134.111 212.172 133.86 212.19C133.682 212.201 133.484 211.859 133.286 211.676C133.422 211.567 133.578 211.35 133.682 211.373C133.996 211.44 134.288 211.599 134.591 211.725Z",
    fill: "#CCCCCC"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5006 153.74C47.323 153.938 47.1351 154.136 46.947 154.332C46.8322 154.019 46.6755 153.712 46.6234 153.388C46.6129 153.285 46.8635 153.14 46.9889 153.013C47.1663 153.256 47.3335 153.497 47.5006 153.74Z",
    fill: "#CCCCCC"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4688 216.506C91.2391 216.689 91.0093 217.002 90.8108 216.989C90.5706 216.973 90.341 216.682 90.111 216.509C90.2365 216.386 90.393 216.144 90.4976 216.162C90.8214 216.217 91.1243 216.375 91.4688 216.506Z",
    fill: "#CCCCCC"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M101.046 216.505C100.816 216.69 100.586 217.008 100.377 216.995C100.137 216.981 99.9073 216.682 99.6776 216.505C99.8029 216.379 99.9596 216.129 100.064 216.149C100.388 216.207 100.701 216.368 101.046 216.505Z",
    fill: "#CCCCCC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M120.241 216.502C120.011 216.687 119.792 217.006 119.594 216.991C119.343 216.973 119.113 216.684 118.873 216.512C119.009 216.389 119.155 216.147 119.27 216.165C119.583 216.217 119.886 216.373 120.241 216.502Z",
    fill: "#CCCCCC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M129.808 216.516C129.568 216.687 129.327 216.972 129.077 216.988C128.889 217 128.69 216.655 128.492 216.469C128.628 216.359 128.784 216.139 128.889 216.16C129.202 216.227 129.505 216.389 129.808 216.516Z",
    fill: "#CCCCCC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6253 220.951C95.824 221.134 96.0118 221.318 96.2103 221.502C95.9073 221.613 95.6044 221.765 95.2807 221.817C95.1763 221.833 95.0407 221.585 94.9152 221.458C95.145 221.29 95.3852 221.12 95.6253 220.951Z",
    fill: "#CCCCCC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M114.811 220.95C114.999 221.135 115.197 221.319 115.385 221.504C115.082 221.614 114.779 221.766 114.455 221.817C114.351 221.833 114.205 221.584 114.09 221.458C114.33 221.288 114.57 221.119 114.811 220.95Z",
    fill: "#CCCCCC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M124.45 220.922C124.628 221.114 124.805 221.309 124.983 221.506C124.68 221.616 124.377 221.766 124.053 221.816C123.949 221.831 123.803 221.583 123.677 221.454C123.928 221.285 124.168 221.115 124.45 220.922Z",
    fill: "#CCCCCC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M134.56 221.218C134.382 221.432 134.184 221.805 134.038 221.785C133.735 221.744 133.453 221.501 133.171 221.339C133.307 221.221 133.442 221.001 133.578 221.006C133.891 221.017 134.205 221.133 134.56 221.218Z",
    fill: "#CCCCCC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M128.461 226.257C128.69 226.075 128.91 225.762 129.098 225.775C129.348 225.792 129.568 226.081 129.797 226.251C129.672 226.374 129.526 226.613 129.421 226.596C129.098 226.542 128.805 226.387 128.461 226.257Z",
    fill: "#CCCCCC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5214 230.479C47.3334 230.659 47.135 230.842 46.9365 231.026C46.8321 230.713 46.6859 230.407 46.6337 230.084C46.6128 229.981 46.8635 229.836 46.9992 229.71C47.1662 229.957 47.3334 230.204 47.5214 230.479Z",
    fill: "#CCCCCC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2729 230.48C76.085 230.659 75.8864 230.841 75.6986 231.025C75.5838 230.713 75.4375 230.406 75.3853 230.084C75.3748 229.981 75.6151 229.836 75.7508 229.71C75.9179 229.957 76.085 230.203 76.2729 230.48Z",
    fill: "#CCCCCC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 235.597C129.588 235.809 129.39 236.179 129.254 236.16C128.952 236.119 128.68 235.875 128.387 235.715C128.523 235.6 128.659 235.381 128.795 235.387C129.108 235.396 129.421 235.513 129.776 235.597Z",
    fill: "#CCCCCC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1537 153.043C18.3729 153.231 18.7384 153.427 18.7175 153.568C18.6758 153.874 18.4356 154.152 18.2685 154.442C18.1536 154.305 17.9342 154.165 17.9447 154.032C17.9552 153.716 18.07 153.405 18.1537 153.043Z",
    fill: "#CCCCCC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2207 240.39C96.0327 240.604 95.8343 240.975 95.6985 240.956C95.3852 240.915 95.1136 240.672 94.8212 240.512C94.9569 240.394 95.0927 240.175 95.2285 240.179C95.5418 240.188 95.8551 240.306 96.2207 240.39Z",
    fill: "#CCCCCC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M124.189 240.996C124.053 240.776 123.918 240.557 123.792 240.338C124.116 240.287 124.429 240.193 124.753 240.206C124.878 240.211 124.993 240.456 125.119 240.591C124.805 240.726 124.492 240.861 124.189 240.996Z",
    fill: "#CCCCCC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M133.745 240.998C133.62 240.778 133.484 240.557 133.348 240.337C133.672 240.287 133.996 240.193 134.32 240.207C134.445 240.214 134.56 240.457 134.685 240.593C134.372 240.729 134.058 240.863 133.745 240.998Z",
    fill: "#CCCCCC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4374 245.18C91.2494 245.396 91.0509 245.773 90.9047 245.753C90.6019 245.711 90.3199 245.467 90.0275 245.305C90.1632 245.185 90.299 244.962 90.4348 244.967C90.7586 244.977 91.0717 245.095 91.4374 245.18Z",
    fill: "#CCCCCC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M100.168 245.807C100.033 245.579 99.8969 245.351 99.761 245.122C100.095 245.069 100.429 244.973 100.753 244.987C100.879 244.993 101.004 245.245 101.119 245.386C100.806 245.527 100.482 245.667 100.168 245.807Z",
    fill: "#CCCCCC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M119.395 245.794C119.26 245.572 119.124 245.35 118.988 245.127C119.312 245.075 119.646 244.98 119.959 244.993C120.095 244.998 120.21 245.245 120.325 245.382C120.022 245.52 119.709 245.658 119.395 245.794Z",
    fill: "#CCCCCC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M129.829 245.265C129.578 245.442 129.338 245.735 129.087 245.75C128.899 245.762 128.69 245.41 128.482 245.221C128.617 245.107 128.774 244.881 128.889 244.904C129.213 244.972 129.515 245.137 129.829 245.265Z",
    fill: "#CCCCCC"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2518 250.063C96.0015 250.232 95.7715 250.511 95.5105 250.53C95.3329 250.541 95.1345 250.197 94.9465 250.013C95.0718 249.904 95.2285 249.686 95.3329 249.708C95.6463 249.776 95.9492 249.937 96.2518 250.063Z",
    fill: "#CCCCCC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M114.069 250.225C114.299 250.04 114.518 249.723 114.717 249.737C114.967 249.754 115.197 250.044 115.427 250.216C115.302 250.339 115.155 250.581 115.04 250.564C114.727 250.51 114.424 250.355 114.069 250.225Z",
    fill: "#CCCCCC"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M124.45 249.674C124.628 249.866 124.805 250.063 124.993 250.26C124.68 250.371 124.377 250.522 124.053 250.571C123.949 250.585 123.803 250.337 123.677 250.209C123.928 250.04 124.168 249.871 124.45 249.674Z",
    fill: "#CCCCCC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M133.745 250.58C133.609 250.361 133.484 250.141 133.348 249.922C133.672 249.872 133.996 249.779 134.32 249.794C134.445 249.798 134.56 250.042 134.675 250.178C134.361 250.312 134.058 250.446 133.745 250.58Z",
    fill: "#CCCCCC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M128.962 255.365C128.837 255.148 128.701 254.932 128.575 254.716C128.889 254.668 129.212 254.576 129.526 254.589C129.641 254.594 129.755 254.836 129.881 254.969C129.568 255.102 129.265 255.234 128.962 255.365Z",
    fill: "#CCCCCC"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7069 158.738C42.4666 158.822 42.2369 158.905 41.9967 158.988C41.9862 158.669 41.955 158.345 41.9862 158.031C41.9967 157.944 42.2264 157.882 42.3517 157.809C42.477 158.118 42.5919 158.427 42.7069 158.738Z",
    fill: "#CCCCCC"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M128.962 264.953C128.826 264.735 128.701 264.518 128.575 264.301C128.889 264.252 129.212 264.16 129.526 264.174C129.651 264.18 129.755 264.421 129.881 264.555C129.568 264.687 129.265 264.82 128.962 264.953Z",
    fill: "#CCCCCC"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M128.45 148.395C128.68 148.211 128.899 147.897 129.098 147.911C129.348 147.927 129.568 148.217 129.808 148.388C129.672 148.511 129.526 148.753 129.421 148.736C129.108 148.681 128.805 148.526 128.45 148.395Z",
    fill: "#CCCCCC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M133.975 268.871C134.173 269.057 134.361 269.243 134.56 269.427C134.246 269.542 133.944 269.693 133.62 269.746C133.515 269.763 133.369 269.511 133.244 269.382C133.484 269.212 133.735 269.041 133.975 268.871Z",
    fill: "#CCCCCC"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M133.975 143.079C134.173 143.264 134.361 143.448 134.56 143.633C134.246 143.747 133.944 143.897 133.62 143.949C133.515 143.966 133.369 143.715 133.244 143.588C133.494 143.418 133.735 143.249 133.975 143.079Z",
    fill: "#CCCCCC"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M123.667 143.597C123.897 143.414 124.126 143.099 124.325 143.113C124.575 143.128 124.795 143.422 125.035 143.595C124.899 143.718 124.753 143.964 124.649 143.945C124.325 143.889 124.022 143.731 123.667 143.597Z",
    fill: "#CCCCCC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M114.069 143.6C114.299 143.415 114.518 143.098 114.717 143.113C114.967 143.13 115.197 143.42 115.437 143.592C115.301 143.715 115.155 143.959 115.04 143.941C114.727 143.886 114.424 143.731 114.069 143.6Z",
    fill: "#CCCCCC"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8943 143.603C95.124 143.417 95.3433 143.097 95.5418 143.112C95.7924 143.13 96.0222 143.419 96.2624 143.591C96.1266 143.714 95.9805 143.959 95.8655 143.94C95.5523 143.888 95.2493 143.732 94.8943 143.603Z",
    fill: "#CCCCCC"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80641 143.437C8.56622 143.607 8.33649 143.888 8.08585 143.902C7.90826 143.914 7.69943 143.575 7.51126 143.394C7.63671 143.285 7.79351 143.068 7.8978 143.09C8.21117 143.154 8.50362 143.313 8.80641 143.437Z",
    fill: "#CCCCCC"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M129.818 138.644C129.568 138.817 129.338 139.105 129.077 139.122C128.889 139.135 128.68 138.786 128.482 138.597C128.617 138.485 128.774 138.263 128.889 138.285C129.202 138.352 129.505 138.515 129.818 138.644Z",
    fill: "#CCCCCC"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M120.231 138.644C119.991 138.815 119.75 139.1 119.5 139.116C119.312 139.127 119.113 138.785 118.915 138.6C119.051 138.489 119.197 138.269 119.312 138.292C119.625 138.358 119.928 138.518 120.231 138.644Z",
    fill: "#CCCCCC"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6464 56.0276C75.8763 56.2198 76.2523 56.4182 76.2313 56.5644C76.2 56.8756 75.9493 57.1618 75.7822 57.4584C75.6569 57.3195 75.4376 57.1775 75.4376 57.0438C75.4481 56.72 75.5629 56.3994 75.6464 56.0276Z",
    fill: "#CCCCCC"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 52.299C129.588 52.5121 129.39 52.8839 129.254 52.864C128.952 52.8223 128.669 52.5801 128.387 52.4192C128.523 52.3012 128.659 52.0829 128.795 52.0871C129.108 52.0975 129.411 52.2144 129.776 52.299Z",
    fill: "#CCCCCC"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M115.416 76.3489C115.176 76.5161 114.946 76.7918 114.696 76.8085C114.518 76.82 114.32 76.4816 114.132 76.2999C114.257 76.1934 114.414 75.9782 114.508 76.0001C114.821 76.0659 115.113 76.2247 115.416 76.3489Z",
    fill: "#CCCCCC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2624 105.09C96.0327 105.273 95.8134 105.585 95.6149 105.572C95.3643 105.556 95.1346 105.266 94.9048 105.094C95.0407 104.972 95.1868 104.73 95.2911 104.749C95.6149 104.803 95.9178 104.959 96.2624 105.09Z",
    fill: "#CCCCCC"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M133.223 114.852C133.463 114.663 133.682 114.339 133.891 114.353C134.142 114.371 134.372 114.666 134.612 114.84C134.476 114.966 134.33 115.212 134.215 115.195C133.891 115.141 133.588 114.983 133.223 114.852Z",
    fill: "#CCCCCC"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M125.004 114.595C124.816 114.812 124.617 115.192 124.482 115.173C124.168 115.129 123.886 114.882 123.594 114.718C123.73 114.598 123.876 114.377 124.012 114.38C124.325 114.391 124.638 114.509 125.004 114.595Z",
    fill: "#CCCCCC"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M129.787 129.067C129.557 129.234 129.327 129.511 129.077 129.526C128.899 129.539 128.701 129.202 128.502 129.02C128.638 128.912 128.784 128.697 128.889 128.719C129.202 128.785 129.495 128.943 129.787 129.067Z",
    fill: "#CCCCCC"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M133.223 86.0992C133.453 85.9102 133.682 85.5864 133.881 85.5999C134.132 85.6177 134.372 85.9123 134.612 86.0877C134.476 86.213 134.33 86.4595 134.215 86.4417C133.891 86.3885 133.578 86.2308 133.223 86.0992Z",
    fill: "#CCCCCC"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M125.025 85.93C124.784 86.1023 124.555 86.3904 124.293 86.4051C124.116 86.4156 123.907 86.072 123.709 85.8871C123.844 85.7765 124.001 85.555 124.105 85.577C124.419 85.6427 124.722 85.8036 125.025 85.93Z",
    fill: "#CCCCCC"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M114.811 240.122C114.999 240.305 115.197 240.488 115.385 240.672C115.082 240.785 114.779 240.934 114.455 240.985C114.351 241.002 114.205 240.754 114.09 240.626C114.33 240.458 114.57 240.29 114.811 240.122Z",
    fill: "#CCCCCC"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8869 100.106L52.0436 100.512L51.6573 100.468L51.8869 100.106Z",
    fill: "#CCCCCC"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4743 100.132L61.6206 100.505L61.2551 100.459L61.4743 100.132Z",
    fill: "#CCCCCC"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M70.759 100.349L71.1557 100.196L71.1139 100.582L70.759 100.349Z",
    fill: "#CCCCCC"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8788 100.413L80.4819 100.565L80.5342 100.183L80.8788 100.413Z",
    fill: "#CCCCCC"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9544 100.349L90.3199 100.215L90.2781 100.565L89.9544 100.349Z",
    fill: "#CCCCCC"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5208 100.348L99.9178 100.205L99.8656 100.573L99.5208 100.348Z",
    fill: "#CCCCCC"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M109.338 100.641L109.192 100.257L109.557 100.302L109.338 100.641Z",
    fill: "#CCCCCC"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M119.886 100.349L120.262 100.211L120.22 100.567L119.886 100.349Z",
    fill: "#CCCCCC"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M129.975 100.416L129.599 100.551L129.641 100.197L129.975 100.416Z",
    fill: "#CCCCCC"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6027 105.207L18.1849 105.369L18.2266 104.966L18.6027 105.207Z",
    fill: "#CCCCCC"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9289 104.907L28.0752 105.303L27.6991 105.258L27.9289 104.907Z",
    fill: "#CCCCCC"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7462 105.209L37.3493 105.354L37.4014 104.982L37.7462 105.209Z",
    fill: "#CCCCCC"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M47.041 105.479L46.8635 105.04L47.2916 105.083L47.041 105.479Z",
    fill: "#CCCCCC"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9209 105.208L56.524 105.36L56.5657 104.977L56.9209 105.208Z",
    fill: "#CCCCCC"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2679 104.912L66.4246 105.303L66.0487 105.257L66.2679 104.912Z",
    fill: "#CCCCCC"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7926 105.473L75.6255 105.041L76.0328 105.084L75.7926 105.473Z",
    fill: "#CCCCCC"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4427 104.915L85.5888 105.302L85.213 105.256L85.4427 104.915Z",
    fill: "#CCCCCC"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M104.607 104.904L104.764 105.304L104.377 105.259L104.607 104.904Z",
    fill: "#CCCCCC"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4852 110.265L13.3182 109.833L13.736 109.875L13.4852 110.265Z",
    fill: "#CCCCCC"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1248 109.629C23.2291 109.748 23.3337 109.867 23.4381 109.986C23.2188 109.966 22.9891 109.946 22.7697 109.926C22.895 109.827 23.0099 109.728 23.1248 109.629Z",
    fill: "#CCCCCC"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2369 110.283C42.1429 110.168 41.955 110.043 41.9758 109.942C41.9863 109.833 42.1848 109.661 42.2892 109.674C42.404 109.687 42.4875 109.882 42.5816 109.998C42.4666 110.093 42.3518 110.188 42.2369 110.283Z",
    fill: "#CCCCCC"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1899 110.008C52.0646 110.108 51.9393 110.295 51.8348 110.283C51.72 110.27 51.5424 110.058 51.5528 109.952C51.5633 109.838 51.7721 109.745 51.887 109.643C51.9914 109.765 52.0855 109.887 52.1899 110.008Z",
    fill: "#CCCCCC"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4116 110.245L61.2551 109.838L61.6518 109.883L61.4116 110.245Z",
    fill: "#CCCCCC"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9886 110.28C70.8946 110.166 70.8006 110.053 70.7065 109.939C70.8215 109.845 70.9468 109.664 71.0512 109.677C71.1557 109.69 71.2497 109.883 71.3436 109.998C71.2288 110.091 71.1139 110.186 70.9886 110.28Z",
    fill: "#CCCCCC"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M80.931 110.009C80.8161 110.105 80.6908 110.286 80.5861 110.272C80.4714 110.259 80.3044 110.054 80.3148 109.952C80.3252 109.841 80.5237 109.753 80.6387 109.655C80.7325 109.773 80.837 109.891 80.931 110.009Z",
    fill: "#CCCCCC"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M109.077 109.936L109.505 109.771L109.463 110.181L109.077 109.936Z",
    fill: "#CCCCCC"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2684 115.076C18.1745 114.961 17.9967 114.835 18.0073 114.734C18.0282 114.624 18.2265 114.451 18.331 114.463C18.4459 114.476 18.5294 114.673 18.6339 114.789C18.5086 114.885 18.3937 114.981 18.2684 115.076Z",
    fill: "#CCCCCC"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9185 114.472L28.0857 114.892L27.6785 114.848L27.9185 114.472Z",
    fill: "#CCCCCC"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5162 114.479L37.6729 114.891L37.2761 114.846L37.5162 114.479Z",
    fill: "#CCCCCC"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0933 114.411C47.1977 114.533 47.3021 114.655 47.4066 114.778C47.1768 114.759 46.9576 114.739 46.7276 114.721C46.8531 114.617 46.968 114.513 47.0933 114.411Z",
    fill: "#CCCCCC"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6179 115.048L56.4508 114.627L56.8686 114.671L56.6179 115.048Z",
    fill: "#CCCCCC"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2053 115.042L66.0487 114.63L66.4455 114.674L66.2053 115.042Z",
    fill: "#CCCCCC"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7823 115.092C75.6779 114.973 75.4898 114.842 75.5003 114.734C75.5107 114.62 75.7301 114.437 75.8345 114.449C75.9494 114.461 76.0434 114.667 76.1478 114.788C76.0225 114.889 75.9076 114.991 75.7823 115.092Z",
    fill: "#CCCCCC"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M85.119 114.728L85.5471 114.57L85.4949 114.966L85.119 114.728Z",
    fill: "#CCCCCC"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M104.273 114.729L104.711 114.561L104.67 114.976L104.273 114.729Z",
    fill: "#CCCCCC"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5479 119.28L13.7046 119.68L13.3182 119.635L13.5479 119.28Z",
    fill: "#CCCCCC"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1353 119.263L23.3023 119.682L22.895 119.639L23.1353 119.263Z",
    fill: "#CCCCCC"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7226 119.294L32.8689 119.677L32.4929 119.631L32.7226 119.294Z",
    fill: "#CCCCCC"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2474 119.831L42.0907 119.422L42.4771 119.466L42.2474 119.831Z",
    fill: "#CCCCCC"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8869 119.261L52.054 119.684L51.6467 119.64L51.8869 119.261Z",
    fill: "#CCCCCC"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4743 119.294L61.6206 119.678L61.2551 119.632L61.4743 119.294Z",
    fill: "#CCCCCC"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 119.833L70.8423 119.421L71.2393 119.465L70.999 119.833Z",
    fill: "#CCCCCC"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3252 119.52L80.743 119.362L80.7013 119.758L80.3252 119.52Z",
    fill: "#CCCCCC"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1737 119.806L90.0275 119.427L90.393 119.474L90.1737 119.806Z",
    fill: "#CCCCCC"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M100.064 119.584L99.6566 119.733L99.6984 119.355L100.064 119.584Z",
    fill: "#CCCCCC"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M109.098 119.518L109.495 119.373L109.453 119.747L109.098 119.518Z",
    fill: "#CCCCCC"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M120.398 119.586L120.012 119.726L120.064 119.363L120.398 119.586Z",
    fill: "#CCCCCC"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48271 124.312L8.84822 124.177L8.80641 124.528L8.48271 124.312Z",
    fill: "#CCCCCC"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2791 124.618L18.1327 124.22L18.5087 124.264L18.2791 124.618Z",
    fill: "#CCCCCC"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8663 124.601L27.7201 124.223L28.0857 124.268L27.8663 124.601Z",
    fill: "#CCCCCC"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7357 124.38L37.3597 124.518L37.4014 124.159L37.7357 124.38Z",
    fill: "#CCCCCC"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0409 124.636L46.8739 124.217L47.2708 124.259L47.0409 124.636Z",
    fill: "#CCCCCC"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3987 124.314L56.7746 124.173L56.7328 124.535L56.3987 124.314Z",
    fill: "#CCCCCC"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2679 124.094L66.4142 124.472L66.0487 124.426L66.2679 124.094Z",
    fill: "#CCCCCC"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0955 124.379L75.6882 124.537L75.73 124.141L76.0955 124.379Z",
    fill: "#CCCCCC"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4426 124.095L85.5784 124.472L85.2234 124.425L85.4426 124.095Z",
    fill: "#CCCCCC"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9569 124.596L94.8212 124.224L95.1763 124.27L94.9569 124.596Z",
    fill: "#CCCCCC"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M104.544 124.609L104.398 124.22L104.764 124.264L104.544 124.609Z",
    fill: "#CCCCCC"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M124.68 124.313L125.056 124.174L125.014 124.532L124.68 124.313Z",
    fill: "#CCCCCC"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M133.588 124.379L133.212 124.516L133.254 124.162L133.588 124.379Z",
    fill: "#CCCCCC"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4852 129.403L13.3391 129.015L13.7151 129.06L13.4852 129.403Z",
    fill: "#CCCCCC"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1353 128.867L23.2919 129.272L22.9054 129.227L23.1353 128.867Z",
    fill: "#CCCCCC"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6496 129.39L32.5138 129.017L32.8689 129.062L32.6496 129.39Z",
    fill: "#CCCCCC"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5398 129.173L42.1534 129.324L42.1952 128.945L42.5398 129.173Z",
    fill: "#CCCCCC"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8243 129.418L51.678 129.014L52.054 129.058L51.8243 129.418Z",
    fill: "#CCCCCC"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1923 129.106L61.5683 128.968L61.5265 129.324L61.1923 129.106Z",
    fill: "#CCCCCC"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0616 128.872L71.2079 129.269L70.8319 129.225L71.0616 128.872Z",
    fill: "#CCCCCC"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M80.649 128.87L80.7952 129.269L80.4193 129.225L80.649 128.87Z",
    fill: "#CCCCCC"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2365 128.893L90.3721 129.261L90.0171 129.215L90.2365 128.893Z",
    fill: "#CCCCCC"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7507 129.404L99.6045 129.015L99.9805 129.06L99.7507 129.404Z",
    fill: "#CCCCCC"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M109.338 129.397L109.192 129.016L109.557 129.061L109.338 129.397Z",
    fill: "#CCCCCC"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M119.897 129.106L120.262 128.97L120.22 129.322L119.897 129.106Z",
    fill: "#CCCCCC"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46177 133.898L8.84819 133.755L8.80637 134.121L8.46177 133.898Z",
    fill: "#CCCCCC"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0283 133.902L18.4459 133.738L18.4042 134.144L18.0283 133.902Z",
    fill: "#CCCCCC"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8662 134.199L27.7095 133.804L28.0961 133.849L27.8662 134.199Z",
    fill: "#CCCCCC"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5163 133.664L37.6625 134.058L37.2866 134.013L37.5163 133.664Z",
    fill: "#CCCCCC"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M47.041 134.239L46.8635 133.798L47.2813 133.84L47.041 134.239Z",
    fill: "#CCCCCC"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6806 133.662L56.8267 134.059L56.4508 134.014L56.6806 133.662Z",
    fill: "#CCCCCC"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M66.268 133.662L66.4246 134.06L66.0382 134.014L66.268 133.662Z",
    fill: "#CCCCCC"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8554 133.629L76.0224 134.07L75.6048 134.028L75.8554 133.629Z",
    fill: "#CCCCCC"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3801 134.198L85.2234 133.805L85.6098 133.85L85.3801 134.198Z",
    fill: "#CCCCCC"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9674 134.188L94.8212 133.806L95.1868 133.852L94.9674 134.188Z",
    fill: "#CCCCCC"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M104.544 134.208L104.388 133.803L104.774 133.847L104.544 134.208Z",
    fill: "#CCCCCC"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4852 139.015L13.3182 138.587L13.736 138.63L13.4852 139.015Z",
    fill: "#CCCCCC"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1354 138.392C23.2292 138.507 23.3233 138.623 23.4277 138.74C23.2084 138.719 22.9995 138.7 22.7802 138.679C22.8951 138.583 23.0204 138.487 23.1354 138.392Z",
    fill: "#CCCCCC"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6496 138.99L32.4929 138.592L32.8898 138.636L32.6496 138.99Z",
    fill: "#CCCCCC"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3101 138.418L42.4771 138.857L42.0594 138.815L42.3101 138.418Z",
    fill: "#CCCCCC"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8869 138.391C51.9809 138.508 52.0854 138.624 52.1793 138.741C51.9705 138.721 51.7511 138.701 51.5423 138.681C51.6573 138.584 51.772 138.487 51.8869 138.391Z",
    fill: "#CCCCCC"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1714 138.688L61.5787 138.537L61.5265 138.919L61.1714 138.688Z",
    fill: "#CCCCCC"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0616 138.417L71.2393 138.858L70.811 138.815L71.0616 138.417Z",
    fill: "#CCCCCC"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 139.029L80.4088 138.584L80.8371 138.626L80.5862 139.029Z",
    fill: "#CCCCCC"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6517 47.6986L85.2859 47.8364L85.3279 47.4792L85.6517 47.6986Z",
    fill: "#CCCCCC"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6131 143.542L18.1849 143.712L18.2266 143.295L18.6131 143.542Z",
    fill: "#CCCCCC"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9289 143.232L28.0857 143.642L27.6888 143.597L27.9289 143.232Z",
    fill: "#CCCCCC"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7566 143.544L37.3493 143.697L37.391 143.313L37.7566 143.544Z",
    fill: "#CCCCCC"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3857 143.553C47.2708 143.651 47.1455 143.833 47.041 143.82C46.9261 143.806 46.7591 143.601 46.7694 143.496C46.7799 143.385 46.9784 143.296 47.0932 143.196C47.1976 143.314 47.2916 143.434 47.3857 143.553Z",
    fill: "#CCCCCC"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6806 143.233L56.8373 143.642L56.4508 143.598L56.6806 143.233Z",
    fill: "#CCCCCC"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9651 143.48L66.3724 143.329L66.3203 143.711L65.9651 143.48Z",
    fill: "#CCCCCC"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1478 143.541C76.0329 143.637 75.918 143.733 75.8031 143.829C75.8241 143.619 75.845 143.408 75.8659 143.197C75.9598 143.312 76.0538 143.427 76.1478 143.541Z",
    fill: "#CCCCCC"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4427 143.242L85.5994 143.641L85.213 143.596L85.4427 143.242Z",
    fill: "#CCCCCC"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M104.607 143.228L104.774 143.644L104.367 143.6L104.607 143.228Z",
    fill: "#CCCCCC"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M100.064 12.9626L99.6566 13.1161L99.6984 12.7329L100.064 12.9626Z",
    fill: "#CCCCCC"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5479 148.039L13.7046 148.437L13.3286 148.391L13.5479 148.039Z",
    fill: "#CCCCCC"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0726 148.592L22.916 148.18L23.3128 148.223L23.0726 148.592Z",
    fill: "#CCCCCC"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4302 148.275L32.806 148.135L32.7644 148.493L32.4302 148.275Z",
    fill: "#CCCCCC"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5502 148.341L42.1429 148.494L42.1952 148.108L42.5502 148.341Z",
    fill: "#CCCCCC"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8869 148.028L52.0436 148.441L51.6573 148.397L51.8869 148.028Z",
    fill: "#CCCCCC"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1923 148.275L61.5683 148.133L61.5265 148.496L61.1923 148.275Z",
    fill: "#CCCCCC"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 148.585L70.8423 148.181L71.2287 148.225L70.999 148.585Z",
    fill: "#CCCCCC"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M80.576 148.584L80.4298 148.181L80.8162 148.225L80.576 148.584Z",
    fill: "#CCCCCC"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1737 148.558L90.0275 148.184L90.393 148.23L90.1737 148.558Z",
    fill: "#CCCCCC"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M100.053 148.341L99.6566 148.492L99.6984 148.111L100.053 148.341Z",
    fill: "#CCCCCC"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 148.044L109.547 148.436L109.171 148.39L109.401 148.044Z",
    fill: "#CCCCCC"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M119.886 148.275L120.262 148.135L120.22 148.493L119.886 148.275Z",
    fill: "#CCCCCC"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M109.098 12.899L109.495 12.7496L109.453 13.1297L109.098 12.899Z",
    fill: "#CCCCCC"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M120.106 13.1882L119.959 12.805L120.335 12.8499L120.106 13.1882Z",
    fill: "#CCCCCC"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9288 152.847L28.0647 153.229L27.7095 153.182L27.9288 152.847Z",
    fill: "#CCCCCC"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4537 153.352L37.3179 152.98L37.6625 153.025L37.4537 153.352Z",
    fill: "#CCCCCC"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1607 17.6926L85.5263 17.5548L85.4845 17.9119L85.1607 17.6926Z",
    fill: "#CCCCCC"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3987 153.07L56.7746 152.931L56.7224 153.291L56.3987 153.07Z",
    fill: "#CCCCCC"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4871 153.136L66.1113 153.274L66.1636 152.916L66.4871 153.136Z",
    fill: "#CCCCCC"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M125.181 17.7595L124.816 17.8984L124.857 17.5391L125.181 17.7595Z",
    fill: "#CCCCCC"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6517 153.136L85.2859 153.276L85.3279 152.917L85.6517 153.136Z",
    fill: "#CCCCCC"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M104.544 153.365L104.398 152.979L104.764 153.023L104.544 153.365Z",
    fill: "#CCCCCC"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M124.68 153.069L125.056 152.931L125.014 153.287L124.68 153.069Z",
    fill: "#CCCCCC"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M120.179 23.4556L120.314 23.8263L119.959 23.7803L120.179 23.4556Z",
    fill: "#CCCCCC"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M124.68 27.2791L125.056 27.1391L125.014 27.4984L124.68 27.2791Z",
    fill: "#CCCCCC"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1923 32.0694L61.5683 31.9294L61.5265 32.2909L61.1923 32.0694Z",
    fill: "#CCCCCC"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2365 31.8503L90.3721 32.2252L90.0171 32.1792L90.2365 31.8503Z",
    fill: "#CCCCCC"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8237 31.8388L99.9701 32.2325L99.594 32.1865L99.8237 31.8388Z",
    fill: "#CCCCCC"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M109.63 32.1363L109.244 32.2836L109.286 31.9107L109.63 32.1363Z",
    fill: "#CCCCCC"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M120.106 32.3558L119.97 31.9788L120.325 32.0236L120.106 32.3558Z",
    fill: "#CCCCCC"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6179 37.1567L56.4717 36.7682L56.8374 36.8132L56.6179 37.1567Z",
    fill: "#CCCCCC"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97354 162.719L8.59745 162.858L8.64972 162.498L8.97354 162.719Z",
    fill: "#CCCCCC"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2679 36.6345L66.4142 37.0187L66.0487 36.9727L66.2679 36.6345Z",
    fill: "#CCCCCC"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6365 162.655L28.0229 162.508L27.9811 162.883L27.6365 162.655Z",
    fill: "#CCCCCC"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7357 162.72L37.3597 162.862L37.4014 162.496L37.7357 162.72Z",
    fill: "#CCCCCC"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4427 36.6354L85.5888 37.0178L85.213 36.9717L85.4427 36.6354Z",
    fill: "#CCCCCC"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3882 162.655L56.7747 162.509L56.7328 162.881L56.3882 162.655Z",
    fill: "#CCCCCC"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2054 162.949L66.0593 162.56L66.4351 162.605L66.2054 162.949Z",
    fill: "#CCCCCC"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7378 36.858L95.1241 36.7201L95.0718 37.0794L94.7378 36.858Z",
    fill: "#CCCCCC"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4426 162.428L85.5784 162.813L85.2234 162.767L85.4426 162.428Z",
    fill: "#CCCCCC"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2494 162.719L94.8735 162.862L94.9153 162.496L95.2494 162.719Z",
    fill: "#CCCCCC"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M104.315 36.862L104.701 36.7148L104.659 37.0909L104.315 36.862Z",
    fill: "#CCCCCC"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M124.899 162.943L124.753 162.561L125.119 162.606L124.899 162.943Z",
    fill: "#CCCCCC"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M113.912 36.8579L114.288 36.7223L114.236 37.0763L113.912 36.8579Z",
    fill: "#CCCCCC"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M125.192 36.9269L124.805 37.0689L124.847 36.7024L125.192 36.9269Z",
    fill: "#CCCCCC"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5479 167.204L13.7046 167.607L13.3182 167.562L13.5479 167.204Z",
    fill: "#CCCCCC"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M22.822 167.449L23.2397 167.289L23.1875 167.688L22.822 167.449Z",
    fill: "#CCCCCC"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9419 167.509L32.5556 167.65L32.6078 167.286L32.9419 167.509Z",
    fill: "#CCCCCC"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2474 167.76L42.0907 167.351L42.4771 167.393L42.2474 167.76Z",
    fill: "#CCCCCC"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4116 41.9368L61.2758 41.564L61.631 41.6089L61.4116 41.9368Z",
    fill: "#CCCCCC"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4116 167.736L61.2654 167.351L61.6415 167.396L61.4116 167.736Z",
    fill: "#CCCCCC"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 167.761L70.8423 167.35L71.2287 167.394L70.999 167.761Z",
    fill: "#CCCCCC"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M80.576 167.761L80.4193 167.347L80.8161 167.39L80.576 167.761Z",
    fill: "#CCCCCC"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2365 167.222L90.3826 167.601L90.0171 167.555L90.2365 167.222Z",
    fill: "#CCCCCC"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M100.064 167.51L99.6566 167.665L99.6984 167.28L100.064 167.51Z",
    fill: "#CCCCCC"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 167.21L109.547 167.606L109.171 167.561L109.401 167.21Z",
    fill: "#CCCCCC"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M120.106 167.735L119.959 167.351L120.335 167.396L120.106 167.735Z",
    fill: "#CCCCCC"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M100.043 41.7206L99.6566 41.8648L99.7088 41.4971L100.043 41.7206Z",
    fill: "#CCCCCC"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0388 172.24L18.446 172.081L18.4043 172.479L18.0388 172.24Z",
    fill: "#CCCCCC"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1588 172.302L27.7723 172.448L27.8141 172.075L28.1588 172.302Z",
    fill: "#CCCCCC"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4432 172.53L37.3074 172.142L37.6729 172.187L37.4432 172.53Z",
    fill: "#CCCCCC"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7694 172.241L47.1977 172.071L47.156 172.489L46.7694 172.241Z",
    fill: "#CCCCCC"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3882 172.236L56.7747 172.089L56.7328 172.464L56.3882 172.236Z",
    fill: "#CCCCCC"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2054 172.529L66.0593 172.143L66.4351 172.188L66.2054 172.529Z",
    fill: "#CCCCCC"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M109.62 41.7206L109.244 41.8638L109.286 41.4971L109.62 41.7206Z",
    fill: "#CCCCCC"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4427 172.009L85.5888 172.394L85.213 172.348L85.4427 172.009Z",
    fill: "#CCCCCC"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7378 172.233L95.1241 172.095L95.0718 172.454L94.7378 172.233Z",
    fill: "#CCCCCC"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M104.304 172.236L104.701 172.088L104.659 172.466L104.304 172.236Z",
    fill: "#CCCCCC"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M120.179 41.4365L120.314 41.8082L119.959 41.7613L120.179 41.4365Z",
    fill: "#CCCCCC"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M124.67 172.236L125.056 172.091L125.014 172.461L124.67 172.236Z",
    fill: "#CCCCCC"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6807 47.4061L56.8268 47.7885L56.4613 47.7446L56.6807 47.4061Z",
    fill: "#CCCCCC"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4871 47.6986L66.1113 47.8364L66.1636 47.4792L66.4871 47.6986Z",
    fill: "#CCCCCC"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9569 47.9158L94.8212 47.5419L95.1763 47.5889L94.9569 47.9158Z",
    fill: "#CCCCCC"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M104.315 47.6308L104.701 47.4845L104.659 47.8574L104.315 47.6308Z",
    fill: "#CCCCCC"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M125.181 47.6996L124.816 47.8353L124.857 47.4803L125.181 47.6996Z",
    fill: "#CCCCCC"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4116 177.312L61.2758 176.941L61.631 176.986L61.4116 177.312Z",
    fill: "#CCCCCC"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M133.296 47.9147L133.16 47.544L133.515 47.5909L133.296 47.9147Z",
    fill: "#CCCCCC"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5502 52.4901L42.1429 52.6447L42.1952 52.2561L42.5502 52.4901Z",
    fill: "#CCCCCC"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8869 52.1716L52.054 52.5884L51.6573 52.5454L51.8869 52.1716Z",
    fill: "#CCCCCC"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M109.338 177.322L109.192 176.941L109.557 176.985L109.338 177.322Z",
    fill: "#CCCCCC"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M120.179 176.814L120.314 177.184L119.959 177.138L120.179 176.814Z",
    fill: "#CCCCCC"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4743 52.2018L61.6206 52.585L61.2551 52.5403L61.4743 52.2018Z",
    fill: "#CCCCCC"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0616 52.1747L71.2183 52.5884L70.8214 52.5454L71.0616 52.1747Z",
    fill: "#CCCCCC"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6491 52.1728L80.8057 52.5894L80.4088 52.5467L80.6491 52.1728Z",
    fill: "#CCCCCC"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8663 183.299L27.7201 182.915L28.0857 182.961L27.8663 183.299Z",
    fill: "#CCCCCC"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4432 183.298L37.3074 182.915L37.6729 182.961L37.4432 183.298Z",
    fill: "#CCCCCC"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6179 183.301L56.4821 182.914L56.8373 182.96L56.6179 183.301Z",
    fill: "#CCCCCC"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2679 182.786L66.4142 183.166L66.0487 183.121L66.2679 182.786Z",
    fill: "#CCCCCC"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3697 183.297L85.2339 182.918L85.5994 182.964L85.3697 183.297Z",
    fill: "#CCCCCC"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0301 182.794L95.1659 183.166L94.8107 183.12L95.0301 182.794Z",
    fill: "#CCCCCC"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M104.544 183.305L104.398 182.914L104.764 182.96L104.544 183.305Z",
    fill: "#CCCCCC"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M124.899 183.293L124.763 182.916L125.118 182.962L124.899 183.293Z",
    fill: "#CCCCCC"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2365 52.2093L90.3721 52.5851L90.0171 52.5393L90.2365 52.2093Z",
    fill: "#CCCCCC"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8324 187.8L23.2397 187.641L23.1874 188.038L22.8324 187.8Z",
    fill: "#CCCCCC"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4302 187.802L32.8166 187.659L32.7644 188.024L32.4302 187.802Z",
    fill: "#CCCCCC"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0071 187.8L42.404 187.646L42.3622 188.033L42.0071 187.8Z",
    fill: "#CCCCCC"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M61.704 187.869L61.3176 188.01L61.3699 187.646L61.704 187.869Z",
    fill: "#CCCCCC"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M70.759 187.799L71.1557 187.645L71.1139 188.034L70.759 187.799Z",
    fill: "#CCCCCC"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6491 187.553L80.7953 187.961L80.4088 187.919L80.6491 187.553Z",
    fill: "#CCCCCC"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9544 187.801L90.3304 187.664L90.2781 188.021L89.9544 187.801Z",
    fill: "#CCCCCC"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8133 187.57L99.9701 187.96L99.594 187.917L99.8133 187.57Z",
    fill: "#CCCCCC"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 187.57L109.547 187.961L109.171 187.917L109.401 187.57Z",
    fill: "#CCCCCC"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M120.398 187.869L120.012 188.006L120.064 187.648L120.398 187.869Z",
    fill: "#CCCCCC"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8133 52.1863L99.9701 52.5863L99.5836 52.5414L99.8133 52.1863Z",
    fill: "#CCCCCC"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M109.641 52.4912L109.244 52.6405L109.286 52.2603L109.641 52.4912Z",
    fill: "#CCCCCC"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M120.168 52.2041L120.314 52.5843L119.949 52.5383L120.168 52.2041Z",
    fill: "#CCCCCC"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2135 57.2182L37.6104 57.0698L37.5583 57.4459L37.2135 57.2182Z",
    fill: "#CCCCCC"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0933 56.9445L47.2709 57.3831L46.8531 57.3424L47.0933 56.9445Z",
    fill: "#CCCCCC"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3777 57.2181L56.7746 57.0677L56.7328 57.4467L56.3777 57.2181Z",
    fill: "#CCCCCC"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1588 192.658L27.7723 192.801L27.8141 192.432L28.1588 192.658Z",
    fill: "#CCCCCC"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4432 192.881L37.3074 192.498L37.6729 192.544L37.4432 192.881Z",
    fill: "#CCCCCC"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3882 192.592L56.7747 192.444L56.7328 192.82L56.3882 192.592Z",
    fill: "#CCCCCC"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2679 192.365L66.4142 192.75L66.0487 192.705L66.2679 192.365Z",
    fill: "#CCCCCC"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1502 192.591L85.5368 192.446L85.4845 192.816L85.1502 192.591Z",
    fill: "#CCCCCC"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7378 192.592L95.1241 192.452L95.0718 192.812L94.7378 192.592Z",
    fill: "#CCCCCC"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9755 57.217L66.3619 57.0719L66.3202 57.4416L65.9755 57.217Z",
    fill: "#CCCCCC"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M125.181 192.659L124.805 192.796L124.857 192.439L125.181 192.659Z",
    fill: "#CCCCCC"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M133.077 192.59L133.453 192.452L133.411 192.81L133.077 192.59Z",
    fill: "#CCCCCC"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4427 56.9872L85.5888 57.3768L85.213 57.3319L85.4427 56.9872Z",
    fill: "#CCCCCC"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M104.847 57.2807L104.45 57.4331L104.492 57.0488L104.847 57.2807Z",
    fill: "#CCCCCC"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M125.192 57.2839L124.805 57.4259L124.847 57.0593L125.192 57.2839Z",
    fill: "#CCCCCC"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7226 61.7852L32.8585 62.1653L32.4929 62.1205L32.7226 61.7852Z",
    fill: "#CCCCCC"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7041 62.0744L61.3281 62.2154L61.3699 61.8531L61.7041 62.0744Z",
    fill: "#CCCCCC"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1632 62.2906L90.0275 61.9188L90.3825 61.9658L90.1632 62.2906Z",
    fill: "#CCCCCC"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M100.053 62.0712L99.6566 62.2217L99.7088 61.8414L100.053 62.0712Z",
    fill: "#CCCCCC"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 61.7737L109.547 62.1674L109.171 62.1235L109.401 61.7737Z",
    fill: "#CCCCCC"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M119.886 62.0088L120.262 61.8666L120.22 62.2291L119.886 62.0088Z",
    fill: "#CCCCCC"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M129.975 62.0754L129.599 62.2144L129.641 61.8531L129.975 62.0754Z",
    fill: "#CCCCCC"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5163 66.5808L37.6521 66.9536L37.297 66.9087L37.5163 66.5808Z",
    fill: "#CCCCCC"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6179 67.0885L56.4821 66.7063L56.8373 66.7523L56.6179 67.0885Z",
    fill: "#CCCCCC"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6517 66.865L85.2859 67.0029L85.3279 66.6457L85.6517 66.865Z",
    fill: "#CCCCCC"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2915 71.6555L70.9051 71.8018L70.9467 71.4289L71.2915 71.6555Z",
    fill: "#CCCCCC"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7507 71.8842L99.6045 71.4978L99.9701 71.5437L99.7507 71.8842Z",
    fill: "#CCCCCC"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M109.338 71.8832L109.192 71.4989L109.557 71.5449L109.338 71.8832Z",
    fill: "#CCCCCC"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6496 207.252L32.5138 206.879L32.8689 206.925L32.6496 207.252Z",
    fill: "#CCCCCC"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4116 207.252L61.2758 206.879L61.631 206.925L61.4116 207.252Z",
    fill: "#CCCCCC"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8133 206.737L99.9595 207.126L99.594 207.082L99.8133 206.737Z",
    fill: "#CCCCCC"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M109.108 206.968L109.495 206.825L109.442 207.191L109.108 206.968Z",
    fill: "#CCCCCC"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M120.179 206.752L120.314 207.125L119.959 207.08L120.179 206.752Z",
    fill: "#CCCCCC"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M119.897 71.5939L120.262 71.4561L120.22 71.8101L119.897 71.5939Z",
    fill: "#CCCCCC"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4432 212.062L37.297 211.672L37.673 211.717L37.4432 212.062Z",
    fill: "#CCCCCC"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M47.041 212.098L46.8635 211.659L47.2813 211.702L47.041 212.098Z",
    fill: "#CCCCCC"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6806 211.529L56.8267 211.925L56.4508 211.88L56.6806 211.529Z",
    fill: "#CCCCCC"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M66.268 211.532L66.4246 211.926L66.0382 211.881L66.268 211.532Z",
    fill: "#CCCCCC"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5211 211.765L75.9598 211.591L75.918 212.016L75.5211 211.765Z",
    fill: "#CCCCCC"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4427 211.534L85.5888 211.924L85.213 211.88L85.4427 211.534Z",
    fill: "#CCCCCC"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0301 211.541L95.1764 211.925L94.8004 211.879L95.0301 211.541Z",
    fill: "#CCCCCC"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M104.304 211.765L104.701 211.61L104.659 211.998L104.304 211.765Z",
    fill: "#CCCCCC"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8662 76.6852L27.7095 76.2925L28.0856 76.3375L27.8662 76.6852Z",
    fill: "#CCCCCC"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M124.962 211.534L125.108 211.923L124.732 211.879L124.962 211.534Z",
    fill: "#CCCCCC"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2239 76.3874L37.6104 76.2434L37.5582 76.611L37.2239 76.3874Z",
    fill: "#CCCCCC"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0933 76.1171L47.2709 76.5516L46.8531 76.5108L47.0933 76.1171Z",
    fill: "#CCCCCC"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9524 216.624L32.5556 216.771L32.6078 216.396L32.9524 216.624Z",
    fill: "#CCCCCC"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5711 216.622L42.1429 216.786L42.1847 216.38L42.5711 216.622Z",
    fill: "#CCCCCC"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8243 216.891L51.6573 216.453L52.0749 216.496L51.8243 216.891Z",
    fill: "#CCCCCC"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7145 216.624L61.3176 216.772L61.3595 216.396L61.7145 216.624Z",
    fill: "#CCCCCC"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 216.884L70.8319 216.456L71.2497 216.5L70.999 216.884Z",
    fill: "#CCCCCC"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5862 216.886L80.4193 216.458L80.8266 216.501L80.5862 216.886Z",
    fill: "#CCCCCC"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9103 76.4533L56.524 76.6006L56.5657 76.2246L56.9103 76.4533Z",
    fill: "#CCCCCC"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4977 76.4523L66.1113 76.5975L66.1531 76.2279L66.4977 76.4523Z",
    fill: "#CCCCCC"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 216.315L109.557 216.722L109.16 216.677L109.401 216.315Z",
    fill: "#CCCCCC"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8554 76.1223L76.0119 76.5516L75.6048 76.5098L75.8554 76.1223Z",
    fill: "#CCCCCC"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3801 76.6822L85.2339 76.2946L85.5994 76.3396L85.3801 76.6822Z",
    fill: "#CCCCCC"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7566 221.413L37.3597 221.562L37.4014 221.182L37.7566 221.413Z",
    fill: "#CCCCCC"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3857 221.417C47.2709 221.514 47.156 221.612 47.041 221.711C46.947 221.594 46.7591 221.467 46.7695 221.362C46.7799 221.25 46.9784 221.158 47.0933 221.057C47.1977 221.177 47.2916 221.296 47.3857 221.417Z",
    fill: "#CCCCCC"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6806 221.102L56.8373 221.51L56.4508 221.466L56.6806 221.102Z",
    fill: "#CCCCCC"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9651 221.347L66.3724 221.193L66.3307 221.581L65.9651 221.347Z",
    fill: "#CCCCCC"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8449 221.05C75.9493 221.166 76.0433 221.282 76.1374 221.397C75.9284 221.377 75.7196 221.356 75.5107 221.336C75.6255 221.241 75.7405 221.146 75.8449 221.05Z",
    fill: "#CCCCCC"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1399 221.348L85.5368 221.2L85.4949 221.578L85.1399 221.348Z",
    fill: "#CCCCCC"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9674 76.6779L94.8212 76.2967L95.1868 76.3438L94.9674 76.6779Z",
    fill: "#CCCCCC"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M104.858 221.411L104.45 221.568L104.492 221.175L104.858 221.411Z",
    fill: "#CCCCCC"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M104.847 76.4523L104.45 76.6028L104.492 76.2216L104.847 76.4523Z",
    fill: "#CCCCCC"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M124.899 76.679L124.753 76.2946L125.129 76.3406L124.899 76.679Z",
    fill: "#CCCCCC"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4277 81.243C23.3128 81.338 23.198 81.433 23.0831 81.5269C23.104 81.3202 23.1249 81.1124 23.1457 80.9056C23.2398 81.0183 23.3337 81.1302 23.4277 81.243Z",
    fill: "#CCCCCC"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0071 226.136L42.404 225.985L42.3622 226.368L42.0071 226.136Z",
    fill: "#CCCCCC"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5841 226.137L51.9913 225.98L51.9392 226.371L51.5841 226.137Z",
    fill: "#CCCCCC"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7041 226.205L61.3281 226.344L61.3699 225.986L61.7041 226.205Z",
    fill: "#CCCCCC"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3019 226.201L70.9051 226.353L70.9467 225.969L71.3019 226.201Z",
    fill: "#CCCCCC"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M80.649 225.896L80.7952 226.298L80.4193 226.254L80.649 225.896Z",
    fill: "#CCCCCC"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4557 226.205L90.0798 226.342L90.1215 225.987L90.4557 226.205Z",
    fill: "#CCCCCC"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M100.053 226.202L99.6566 226.35L99.7088 225.973L100.053 226.202Z",
    fill: "#CCCCCC"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M109.108 226.138L109.495 225.993L109.453 226.364L109.108 226.138Z",
    fill: "#CCCCCC"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M120.179 225.919L120.314 226.295L119.949 226.249L120.179 225.919Z",
    fill: "#CCCCCC"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6495 81.4842L32.5033 81.0872L32.8897 81.1322L32.6495 81.4842Z",
    fill: "#CCCCCC"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5711 81.2461L42.1429 81.4142L42.1847 80.9997L42.5711 81.2461Z",
    fill: "#CCCCCC"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8139 81.5312C51.72 81.4163 51.5424 81.2908 51.5528 81.1895C51.5737 81.0799 51.7721 80.9076 51.8765 80.9191C51.9811 80.9327 52.075 81.129 52.169 81.2449C52.0541 81.3399 51.9393 81.4361 51.8139 81.5312Z",
    fill: "#CCCCCC"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9 230.996L56.524 231.137L56.5762 230.773L56.9 230.996Z",
    fill: "#CCCCCC"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4871 230.997L66.1113 231.134L66.1636 230.779L66.4871 230.997Z",
    fill: "#CCCCCC"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4426 230.714L85.5784 231.087L85.2234 231.042L85.4426 230.714Z",
    fill: "#CCCCCC"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9569 231.213L94.8212 230.841L95.1763 230.888L94.9569 231.213Z",
    fill: "#CCCCCC"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M104.837 230.995L104.45 231.14L104.492 230.768L104.837 230.995Z",
    fill: "#CCCCCC"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M124.899 231.211L124.763 230.84L125.118 230.887L124.899 231.211Z",
    fill: "#CCCCCC"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M133.578 230.998L133.212 231.133L133.254 230.781L133.578 230.998Z",
    fill: "#CCCCCC"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5841 235.724L51.9913 235.565L51.9496 235.961L51.5841 235.724Z",
    fill: "#CCCCCC"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1923 235.725L61.5683 235.583L61.5265 235.946L61.1923 235.725Z",
    fill: "#CCCCCC"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M70.999 236.029L70.8528 235.628L71.2287 235.674L70.999 236.029Z",
    fill: "#CCCCCC"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6491 235.481L80.7953 235.885L80.4088 235.841L80.6491 235.481Z",
    fill: "#CCCCCC"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9544 235.725L90.3304 235.589L90.2781 235.943L89.9544 235.725Z",
    fill: "#CCCCCC"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8133 235.49L99.9701 235.883L99.594 235.84L99.8133 235.49Z",
    fill: "#CCCCCC"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M109.338 236.021L109.192 235.63L109.568 235.676L109.338 236.021Z",
    fill: "#CCCCCC"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M120.106 236.01L119.97 235.634L120.335 235.68L120.106 236.01Z",
    fill: "#CCCCCC"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4116 81.4842L61.2654 81.0872L61.6518 81.1322L61.4116 81.4842Z",
    fill: "#CCCCCC"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7275 81.1845L71.1662 81.0163L71.1244 81.4319L70.7275 81.1845Z",
    fill: "#CCCCCC"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6806 240.277L56.8373 240.68L56.4508 240.637L56.6806 240.277Z",
    fill: "#CCCCCC"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9651 240.52L66.3724 240.367L66.3307 240.752L65.9651 240.52Z",
    fill: "#CCCCCC"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1478 240.58C76.0329 240.677 75.918 240.774 75.8031 240.87C75.8241 240.659 75.845 240.448 75.8659 240.235C75.9598 240.351 76.0538 240.465 76.1478 240.58Z",
    fill: "#CCCCCC"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1295 240.519L85.5368 240.368L85.495 240.751L85.1295 240.519Z",
    fill: "#CCCCCC"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6387 80.917L80.8162 81.3493L80.3984 81.3065L80.6387 80.917Z",
    fill: "#CCCCCC"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M104.544 240.834L104.388 240.421L104.785 240.465L104.544 240.834Z",
    fill: "#CCCCCC"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M109.338 139.002L109.181 138.591L109.578 138.634L109.338 139.002Z",
    fill: "#CCCCCC"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M100.085 81.2461L99.6566 81.409L99.6984 81.0069L100.085 81.2461Z",
    fill: "#CCCCCC"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 80.9339L109.568 81.3473L109.16 81.3024L109.401 80.9339Z",
    fill: "#CCCCCC"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8582 245.953C61.0252 245.657 61.2027 245.359 61.3803 245.062C61.1923 245.354 61.0147 245.644 60.8373 245.935L60.8582 245.953Z",
    fill: "#CCCCCC"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M71.375 245.373C71.2497 245.472 71.1348 245.571 71.0094 245.669C71.0304 245.453 71.0512 245.237 71.0721 245.021C71.1766 245.139 71.2706 245.256 71.375 245.373Z",
    fill: "#CCCCCC"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9416 245.372C80.8266 245.471 80.7116 245.57 80.5967 245.668C80.6176 245.452 80.6387 245.237 80.649 245.022C80.7534 245.139 80.8474 245.256 80.9416 245.372Z",
    fill: "#CCCCCC"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3416 85.6783C18.4356 85.7942 18.5401 85.9091 18.634 86.0251C18.4252 86.0042 18.2162 85.9832 17.9968 85.9634C18.1118 85.8683 18.2266 85.7733 18.3416 85.6783Z",
    fill: "#CCCCCC"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9185 85.7242L28.0857 86.1368L27.6888 86.0929L27.9185 85.7242Z",
    fill: "#CCCCCC"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M109.067 245.313L109.505 245.144L109.463 245.561L109.067 245.313Z",
    fill: "#CCCCCC"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7669 86.0397L37.3493 86.1964L37.391 85.8017L37.7669 86.0397Z",
    fill: "#CCCCCC"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4067 86.0428C47.2813 86.1472 47.1663 86.2516 47.041 86.3571C46.9366 86.2338 46.7382 86.1002 46.7487 85.9895C46.7591 85.8704 46.968 85.7722 47.0933 85.6657C47.1977 85.791 47.3021 85.9174 47.4067 86.0428Z",
    fill: "#CCCCCC"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1478 250.163C76.0329 250.261 75.918 250.361 75.8031 250.458C75.8241 250.244 75.845 250.03 75.8659 249.816C75.9598 249.931 76.0538 250.047 76.1478 250.163Z",
    fill: "#CCCCCC"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4427 249.869L85.5888 250.265L85.213 250.219L85.4427 249.869Z",
    fill: "#CCCCCC"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6807 85.7202L56.8477 86.139L56.4404 86.095L56.6807 85.7202Z",
    fill: "#CCCCCC"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M104.868 250.168L104.45 250.327L104.492 249.928L104.868 250.168Z",
    fill: "#CCCCCC"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5291 86.0387L66.1113 86.1964L66.1531 85.8026L66.5291 86.0387Z",
    fill: "#CCCCCC"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8449 85.6638C75.9493 85.7839 76.0537 85.9039 76.1477 86.0241C75.9284 86.0042 75.709 85.9833 75.4897 85.9635C75.6152 85.8643 75.73 85.764 75.8449 85.6638Z",
    fill: "#CCCCCC"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6933 86.0387L85.2757 86.1953L85.3278 85.8047L85.6933 86.0387Z",
    fill: "#CCCCCC"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M80.576 255.198L80.4298 254.796L80.8162 254.841L80.576 255.198Z",
    fill: "#CCCCCC"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9544 254.893L90.3199 254.76L90.2781 255.111L89.9544 254.893Z",
    fill: "#CCCCCC"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8237 254.663L99.9701 255.053L99.594 255.008L99.8237 254.663Z",
    fill: "#CCCCCC"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M109.338 255.19L109.192 254.801L109.568 254.845L109.338 255.19Z",
    fill: "#CCCCCC"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M120.398 254.962L120.012 255.099L120.064 254.743L120.398 254.962Z",
    fill: "#CCCCCC"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M104.879 86.0375L104.44 86.2057L104.482 85.7932L104.879 86.0375Z",
    fill: "#CCCCCC"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7481 259.687L95.1136 259.551L95.0718 259.905L94.7481 259.687Z",
    fill: "#CCCCCC"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M104.315 259.689L104.701 259.544L104.659 259.915L104.315 259.689Z",
    fill: "#CCCCCC"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M125.192 259.756L124.805 259.893L124.857 259.535L125.192 259.756Z",
    fill: "#CCCCCC"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M133.578 259.754L133.212 259.892L133.254 259.537L133.578 259.754Z",
    fill: "#CCCCCC"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0726 91.085L22.9054 90.661L23.3128 90.7049L23.0726 91.085Z",
    fill: "#CCCCCC"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 264.25L109.547 264.642L109.171 264.598L109.401 264.25Z",
    fill: "#CCCCCC"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M120.106 264.766L119.97 264.389L120.335 264.435L120.106 264.766Z",
    fill: "#CCCCCC"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7226 90.5367L32.8585 90.9211L32.4929 90.8762L32.7226 90.5367Z",
    fill: "#CCCCCC"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3101 90.5149L42.4666 90.9243L42.0697 90.8814L42.3101 90.5149Z",
    fill: "#CCCCCC"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8243 91.083L51.6676 90.661L52.0645 90.7049L51.8243 91.083Z",
    fill: "#CCCCCC"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4743 90.5379L61.6206 90.9212L61.2551 90.8764L61.4743 90.5379Z",
    fill: "#CCCCCC"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3123 90.8271L70.9051 90.9868L70.9467 90.5889L71.3123 90.8271Z",
    fill: "#CCCCCC"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M80.576 91.0767L80.4298 90.6631L80.8162 90.707L80.576 91.0767Z",
    fill: "#CCCCCC"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M89.944 90.7645L90.3304 90.6256L90.2782 90.9859L89.944 90.7645Z",
    fill: "#CCCCCC"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8238 90.5199L99.9701 90.9252L99.5836 90.8803L99.8238 90.5199Z",
    fill: "#CCCCCC"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M109.098 90.7633L109.495 90.613L109.453 90.9942L109.098 90.7633Z",
    fill: "#CCCCCC"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M120.168 90.5367L120.314 90.9211L119.949 90.8762L120.168 90.5367Z",
    fill: "#CCCCCC"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2791 95.862L18.1327 95.4567L18.5087 95.5007L18.2791 95.862Z",
    fill: "#CCCCCC"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8663 95.8463L27.7201 95.4621L28.0857 95.508L27.8663 95.8463Z",
    fill: "#CCCCCC"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7357 95.6208L37.3597 95.7618L37.4014 95.3993L37.7357 95.6208Z",
    fill: "#CCCCCC"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1037 95.3012L47.2605 95.7158L46.8635 95.673L47.1037 95.3012Z",
    fill: "#CCCCCC"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6179 95.8475L56.4717 95.4621L56.8374 95.508L56.6179 95.8475Z",
    fill: "#CCCCCC"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4977 95.6208L66.1113 95.7618L66.1636 95.4014L66.4977 95.6208Z",
    fill: "#CCCCCC"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8554 95.3033L76.0016 95.7149L75.6152 95.672L75.8554 95.3033Z",
    fill: "#CCCCCC"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1502 95.555L85.5368 95.415L85.4845 95.7753L85.1502 95.555Z",
    fill: "#CCCCCC"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7481 95.556L95.1136 95.4204L95.0718 95.7733L94.7481 95.556Z",
    fill: "#CCCCCC"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M104.544 95.8505L104.398 95.4609L104.764 95.5069L104.544 95.8505Z",
    fill: "#CCCCCC"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M124.899 95.8401L124.763 95.463L125.118 95.509L124.899 95.8401Z",
    fill: "#CCCCCC"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M133.296 95.8389L133.16 95.4651L133.515 95.512L133.296 95.8389Z",
    fill: "#CCCCCC"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5583 100.119L13.6941 100.509L13.3286 100.464L13.5583 100.119Z",
    fill: "#CCCCCC"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8324 100.35L23.2397 100.192L23.1874 100.586L22.8324 100.35Z",
    fill: "#CCCCCC"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7226 100.132L32.8585 100.504L32.5033 100.458L32.7226 100.132Z",
    fill: "#CCCCCC"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M42.31 100.113L42.4562 100.51L42.0802 100.465L42.31 100.113Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyContactIcon1);
export default __webpack_public_path__ + "static/media/whyContactIcon1.330c52edcacf1dc8689fae01f6381e2b.svg";
export { ForwardRef as ReactComponent };